import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import withTranslations from '../../translations';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import moment from 'moment';

import {
  AlertDialog,
  Button,
  Checkbox,
  Chip,
  Collapse,
  ConfirmationDialog,
  DatePicker,
  DialogContentText,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Loader,
  MultiStepper,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Step,
  StepConnector,
  Stepper,
  SuperSelect,
  TextField,
  Typography,
} from '../../components/base';

import {
  userHasPermission,
  userHasPermissionWithId,
  userHasReleasePermission,
  userHasReportPermissionWithId,
  userHasReopenReportPermission,
  userHasRoles,
  userIsActionRequester
} from '../../utils/permissions';

import { camelCaseToDash, removeLeadingZeros } from '../../utils/utils';

import { permissions } from '../../constants/permissions';
import { rootUrl } from '../../constants/urls';
import { timeFormat, isValidDate, isSameDate } from '../../constants/time';

import {
  addTeamMember,
  approveAction,
  approveCommercialDecisionAction,
  chooseReleaseMethod,
  clearJob,
  clearSearch,
  deleteJob,
  getMaterialNumberOptions,
  getInitialWarrantyCodes,
  editInitialWarrantyCode,
  clearMaterialNumberOptions,
  proposeWarranty,
  editTechnicalWarrantyProposal,
  deleteTechnicalWarrantyProposal,
  amendApprovedTecnicalWarrantyProposal,
  deleteApprovedTecnicalWarrantyProposal,
  amendCommercialDecision,
  deleteCommercialDecision,
  rateTechnicalDecision,
  reclassifyTechnicalDecision,
  removeTeamMember,
  reopenJob,
  requestReportApproval,
  requestReportLevel,
  searchTeamMember,
  setEquipmentSerialNumber,
  setMaterialNumber,
  setPrice,
  setReleaseMethod,
  setStatus,
  setWarrantyDate,
  verifyJob,
  deleteImportedJob,
} from '../../actions/singleJob';

import {
  isTechnicalDecisionDeclined,
  getCommercialWarrantyOptions,
  getReclassifableTechnicalWarrantyOptions,
  getReleaseMethodOptions,
  getReleaseMethodOptionsWithSendBackOption,
  getStatusOptions,
  getTechnicalWarrantyOptions,
  getWarrantyExpiredSubcategoryOptions,
  reclassifiableCategories,
  rolesThatCanReclassify,
  statusesThatCannotBeManuallySet,
} from './constants';

import {
  jobActions,
  isLastActionApproved,
  isPending,
  isApproved,
  getPotentialResponders,
  hasAlert,
  statuses,
  getJobProgress,
  getJobStatus,
  otherStatusBranch,
  warrantyTypes,
} from '../../constants/job';

import {
  headerHeight,
  subHeaderHeight,
} from '../../constants/styles';

import {
  reportLevelOptions,
  technicalWarrantyDecisionOptions,
  technicalWarrantyRateOptions,
  commercialWarrantyDecisionOptions,
} from '../../constants/globalFormValues';

import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

const styles = theme => ({
  jobSummary: {
    margin: `${headerHeight + subHeaderHeight + theme.spacing(6)}px ${theme.spacing()}px ${theme.spacing()}px`,
    padding: theme.spacing(2),
    minHeight: 300,
    position: 'relative',

    [theme.breakpoints.up('sm')]: {
      margin: `${headerHeight + subHeaderHeight + theme.spacing(6)}px ${theme.spacing(4)}px ${theme.spacing(4)}px`,
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    },

    '&.closed': {
      margin: `${theme.spacing(6)}px ${theme.spacing()}px ${theme.spacing()}px`,

      [theme.breakpoints.up('sm')]: {
        margin: `${theme.spacing(6)}px  ${theme.spacing(4)}px ${theme.spacing(4)}px`
      },
    },

    '& section': {
      marginBottom: theme.spacing(3),

      [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(4),
      },

      '& header': {
        marginBottom: theme.spacing(2),

        '& h6': {
          fontSize: 20,
        },
      },
    },
  },
  jobSummaryHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
  },
  deleteButton: {
    fontSize: 20,
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    color: theme.palette.error.light,
    '&:hover': {
      background: 'inherit',
    },
  },
  deleteIcon: {
    marginTop: -2,
  },
  outlinedSection: {
    border: '1px solid #666',
    borderRadius: 8,
    padding: `0 ${theme.spacing()}px ${theme.spacing()}px`,
    background: theme.palette.background.default,

    '&.hasAlert': {
      borderColor: theme.palette.error.light,
      background: `rgba(229, 115, 115, 0.15)`,
      paddingLeft: theme.spacing(3),

      '& header': {
        backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.paper} 55%, transparent 45%)`,
      }
    },

    [theme.breakpoints.up('sm')]: {
      padding: `0 ${theme.spacing(2)}px ${theme.spacing(2)}px`,
    },

    '& header': {
      position: 'relative',
      width: 'fit-content',
      margin: '0 !important',
      top: -16,
      zIndex: 3,
      backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.paper} 55%, transparent 45%)`,
    }
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  fieldAction: {
    textAlign: 'right',
  },
  fieldActionNotOutlined: {
    textAlign: 'right',
    marginLeft: -theme.spacing(),

    [theme.breakpoints.up('sm')]: {
      marginLeft: -theme.spacing(2),
    },
  },
  editButton: {
    minHeight: 24,
    minWidth: 'fit-content',
    padding: 0,
    textAlign: 'right',

    '&:hover': {
      background: 'inherit',
    },

    '&.jobStatus': {
      marginTop: theme.spacing(0.5),
      marginLeft: -(theme.spacing(0.5) + 1),

      [theme.breakpoints.up('sm')]: {
        marginLeft: -(theme.spacing() + 3),
      },
    }
  },
  progressBar: {
    marginTop: theme.spacing(2),
    padding: 0,

    '& .stepContainer': {
      paddingLeft: theme.spacing(7),
      flexDirection: 'row',
      justifyContent: 'flex-start',

      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-end',
        paddingLeft: 0,
      },
    },

    '& .stepIcon': {
      marginRight: theme.spacing(),

      [theme.breakpoints.up('sm')]: {
        marginRight: 0,
      },
    },
  },
  stepConnector: {
    marginLeft: 66,

    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
      maxWidth: 30,
      marginRight: theme.spacing(),
    },
  },
  radioOptions: {
    flexDirection: 'row',

    '&.block': {
      flexDirection: 'column',
    },

    '& > span': {
      padding: 0,
      margin: theme.spacing(),
    },
  },
  radioButton: {
    background: theme.palette.background.default,
  },
  radioButtonSelected: {
    background: theme.palette.action.selected,
  },
  formControl: {
    display: 'block',
  },
  editJobStatusFieldContainer: {
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    '& label': {
      display: 'block',
      fontSize: 14,
      flex: '4 0 75%',

      [theme.breakpoints.up('sm')]: {
        fontSize: 16,
      },
    },
    '& div': {
      fontSize: 14,
      flex: '1 0 25%',

      [theme.breakpoints.up('sm')]: {
        fontSize: 16,
      },
    },
  },
  alertList: {
    marginTop: 0,
    paddingLeft: theme.spacing(5),

    '&.hasAlert': {
      paddingLeft: theme.spacing(2),
    },
  },
  alertListItem: {
    marginBottom: theme.spacing(),
  },
  teamMemberList: {
    padding: 0,
    overflow: 'hidden',
  },
  teamMemberListItem: {
    padding: 0,
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  removeTeamMemberButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 24,
  },
  removeTeamMemberButton: {
    padding: 0,
    color: theme.palette.error.light,
  },
  teamMemberSearchResultsList: {
    overflowX: 'hidden',

    [theme.breakpoints.up('sm')]: {
      maxHeight: 300,
    }
  },
  teamMemberSearchResult: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  teamMemberSearchResultCheckbox: {
    paddingLeft: 0
  },
  teamMemberSearchResultText: {
    paddingLeft: 0,
    paddingRight: 0
  },
  verifySection: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  priceError: {
    color: theme.palette.error.light,
    position: 'absolute',
    bottom: -20,
  },
  editMaterialNumberSelect: {
    marginTop: theme.spacing(2),
  },
  error: {
    color: theme.palette.error.main,
    position: 'absolute',
    bottom: -20,
    width: '100%',
  },
  textField: {
    '& fieldset': {
      borderColor: `${theme.palette.secondary.main} !important`,
    },
  },
  required: {
    color: theme.palette.secondary.main,
  },
  textareaDisabled: {
    '& fieldset': {
      borderColor: `${theme.palette.text.disabled} !important`,
    },
  },
  proposedDateDiv: {
    marginTop: theme.spacing(2),
  },
  releaseJobField: {
    display: 'flex',
    alignItems: 'center',
  },
  rateButton: {
    marginRight: theme.spacing(1),
  }
});

class JobSummary extends Component {
  state = {
    reportLevelDialog: false,
    approveReportLevelDialog: false,
    technicalWarrantyDialog: false,
    editTechnicalWarrantyDialog: false,
    approveTechnicalWarrantyDialog: false,
    amendTechnicalWarrantyDialog: false,
    reclassifyTechnicalWarrantyDialog: false,
    commercialDecisionDialog: false,
    approveCommercialDecisionReason: '',
    amendCommercialDecisionDialog: false,
    approveCommercialDecisionDialog: false,
    editPriceDialog: false,
    reportStatusDialog: false,
    approveReportStatusDialog: false,
    reopenJobDialog: false,
    releaseJobDialog: false,
    editJobStatusDialog: false,
    editEquipmentSerialNumberDialog: false,
    editMaterialNumberDialog: false,
    warrantyStartDialog: false,
    warrantyEndDialog: false,
    deleteConfirmationDialog: false,
    deleteImportedJobConfirmationDialog: false,
    removeTeamMemberDialog: false,
    rateTechnicalDecisionDialog: false,
    teamDialog: false,
    verifyJobDialog: false,
    editReleaseMethodDialog: false,
    changeInitialWarrantyCodeDialog: false,
    warrantyStartDate: null,
    warrantyEndDate: null,
    technicalWarranty: {},
    commercialDecision: {},
    jobStatus: [],
    reportLevel: 0,
    price: null,
    releaseMethod: '',
    teamSearchQuery: '',
    selectedTeamMembers: [],
    equipmentSerialNumber: null,
    materialNumberSearchQuery: '',
    materialNumber: null,
    approveTechnicalWarrantyReason: '',
    reclassifiedTechnicalDecision: {},
    initialWarrantyCode: '',
    partNumbers: '',
    shipToAddress: '',
    proposedDate: null,
    reportLevelReason: '',
    chosenMethod: this.props.chosenMethod,
    chosenProposedDate: this.props.chosenProposedDate,
    chosenPartNumbers: this.props.chosenPartNumbers || '',
    chosenShipToAddress: this.props.chosenShipToAddress || '',
    rateDecision: this.props.rateDecision,
    rateComment: this.props.rateComment,
  }

  componentDidMount() {
    this.setState({
      equipmentSerialNumber: this.props.job.equipmentSerialNumber,
      warrantyStartDate: this.props.job.equipmentWarrantyStartDate,
      warrantyEndDate: this.props.job.equipmentWarrantyEndDate,
      reportLevel: this.props.job.reportLevel,
      initialWarrantyCode: this.props.job.initialWarrantyCode,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.job.deleted) {
      this.props.history.push(rootUrl());
    }

    if (prevProps.searchedTeamMembers !== this.props.searchedTeamMembers) {
      this.setState({ searchedTeamMembers: this.props.searchedTeamMembers })
    }

    if (prevProps.job.reportLevel !== this.props.job.reportLevel) {
      this.setState({
        reportLevel: this.props.job.reportLevel,
        initialWarrantyCode: this.props.job.initialWarrantyCode,
      })
    }
  }

  closeDialog = dialog => this.setState({ [dialog]: false })

  openDialog = dialog => this.setState({ [dialog]: true })

  openDialogWithInitialWarrantyCodesAPICall = async (dialog) => {
    !this.props.job.initialWarrantyCodeOptions && await this.props.actions.getInitialWarrantyCodes();
    this.setState({ [dialog]: true });
  }

  openDialogWithData = (dialog, data) => {
    // If opening edit/amend technical warranty dialogs and category is one of the new subcategories,
    // parse it to set category to 'WARRANTY_EXPIRED' and warrantyExpiredSubcategory to the subcategory
    if (data && data.category &&
        (dialog === 'editTechnicalWarrantyDialog' || dialog === 'amendTechnicalWarrantyDialog') &&
        data.category.startsWith('OUT_OF_STANDARD_WARRANTY_PERIOD_-_')) {
      const parsedData = {
        ...data,
        category: 'WARRANTY_EXPIRED',
        warrantyExpiredSubcategory: data.category,
      };
      this.setState({ [dialog]: parsedData });
    } else {
      this.setState({ [dialog]: data });
    }
  }

  handleReportLevelCancel = () => {
    this.setState(
      {
        reportLevel: this.props.job.reportLevel,
        initialWarrantyCode: this.props.job.initialWarrantyCode,
        reportLevelReason: '',
      },
      () => this.closeDialog('reportLevelDialog')
    )
  }

  handleSetReportLevel = e => this.setState({ reportLevel: Number(e.target.value) })

  handleReportLevelConfirm = () => {
    const { reportLevel, reportLevelReason } = this.state;
    const { job } = this.props;
    const initialWarrantyCode = this.state.initialWarrantyCode || job.initialWarrantyCode;
    let data = { level: reportLevel, reason: reportLevelReason }

    if (reportLevel > 1) {
      data = { ...data, initialWarrantyCode };
    }

    this.handleReportLevelCancel();
    this.props.actions.requestReportLevel(job.id, data);
  }

  handleWarrantyDecisionCancel = warrantyType => {
    this.setState(
      { [warrantyType]: {} },
      () => this.closeDialog(`${warrantyType}Dialog`))
  }

  handleInput = field => e => this.setState({ [field]: e.target.value })

  handleRadioSelect = field => e => this.setState({
    [field]: {
      ...this.state[field],
      decision: e.target.value,
      category: null,
      serviceInformationBulletin: null,
      warrantyExpiredSubcategory: null,
    }
  })

  handleMaterialNumberSelect = e => this.setState({ materialNumber: e.value })

  handleWarrantyDecisionCategory = warrantyType => e => {
    const newCategory = e.target.value;
    this.setState(prevState => {
      const updated = Object.assign({}, prevState[warrantyType], { 
        category: newCategory,
        // Only clear warrantyExpiredSubcategory if switching away from WARRANTY_EXPIRED
        warrantyExpiredSubcategory: newCategory === 'WARRANTY_EXPIRED' ? prevState[warrantyType].warrantyExpiredSubcategory : null
      });
      return { [warrantyType]: updated };
    },
      // Clear SIB if present, and if category is changed
      () => {
        if (warrantyType === 'technicalWarranty' && newCategory !== 'DESIGN' && this.state.technicalWarranty.serviceInformationBulletin) {
          const { decision, category } = this.state.technicalWarranty;
          this.setState({ technicalWarranty: { decision, category } })
        }
      }
    );
  }

  handleWarrantyExpiredSubcategory = warrantyType => e => {
    const subcategory = e.target.value;
    this.setState(prevState => {
      const updated = Object.assign({}, prevState[warrantyType], { warrantyExpiredSubcategory: subcategory });
      // Keep category as 'WARRANTY_EXPIRED' - don't change it to subcategory
      return { [warrantyType]: updated };
    });
  }

  handleReason = warrantyType => e => {
    e.persist();
    this.setState(prevState => ({
      [warrantyType]: Object.assign({}, prevState[warrantyType], { reason: e.target.value.trim() && e.target.value })
    }))
  }

  handleReportLevelReason = e => this.setState({ reportLevelReason: e.target.value })

  handleSIB = techWarranty => e => {
    e.persist();
    this.setState(prevState => ({
      [techWarranty]: Object.assign({}, prevState[techWarranty], { serviceInformationBulletin: e.target.value.trim() && e.target.value })
    }));
  }

  handleWarrantyConfirm = warrantyType => {
    const warranty = camelCaseToDash(warrantyType);
    const warrantyData = { ...this.state[warrantyType] };

    // If WARRANTY_EXPIRED is selected, use the subcategory as the final category
    if (warrantyData.category === 'WARRANTY_EXPIRED' && warrantyData.warrantyExpiredSubcategory) {
      warrantyData.category = warrantyData.warrantyExpiredSubcategory;
      delete warrantyData.warrantyExpiredSubcategory;
    }

    this.handleWarrantyDecisionCancel('technicalWarranty');
    this.handleWarrantyDecisionCancel('commercialDecision');
    this.props.actions.proposeWarranty(this.props.job.id, warranty, warrantyData);
  }

  handleEditTechnicalWarrantyProposalConfirm = () => {
    const { editTechnicalWarrantyDialog } = this.state;
    this.closeDialog('editTechnicalWarrantyDialog');
    let category = editTechnicalWarrantyDialog.category;

    // If WARRANTY_EXPIRED is selected, use the subcategory as the final category
    if (category === 'WARRANTY_EXPIRED' && editTechnicalWarrantyDialog.warrantyExpiredSubcategory) {
      category = editTechnicalWarrantyDialog.warrantyExpiredSubcategory;
    }

    const editedProposalData = {
      category,
      decision: editTechnicalWarrantyDialog.decision,
      reason: editTechnicalWarrantyDialog.reason,
      serviceInformationBulletin: category === 'DESIGN'
        ? editTechnicalWarrantyDialog.serviceInformationBulletin
        : null,
    };
    this.props.actions.editTechnicalWarrantyProposal(this.props.job.id, editTechnicalWarrantyDialog.id, editedProposalData);
  }

  handleDeleteTechnicalWarrantyProposal = () => {
    const { editTechnicalWarrantyDialog } = this.state;
    this.closeDialog('editTechnicalWarrantyDialog');
    this.props.actions.deleteTechnicalWarrantyProposal(this.props.job.id, editTechnicalWarrantyDialog.id);
  }

  handleAmendTechnicalWarrantyDecisionConfirm = () => {
    const { amendTechnicalWarrantyDialog } = this.state;
    this.closeDialog('amendTechnicalWarrantyDialog');
    let category = amendTechnicalWarrantyDialog.category;

    // If WARRANTY_EXPIRED is selected, use the subcategory as the final category
    if (category === 'WARRANTY_EXPIRED' && amendTechnicalWarrantyDialog.warrantyExpiredSubcategory) {
      category = amendTechnicalWarrantyDialog.warrantyExpiredSubcategory;
    }

    const amendedData = {
      category,
      decision: amendTechnicalWarrantyDialog.decision,
      reason: amendTechnicalWarrantyDialog.reason,
      serviceInformationBulletin: category === 'DESIGN'
        ? amendTechnicalWarrantyDialog.serviceInformationBulletin
        : null,
    };
    this.props.actions.amendApprovedTecnicalWarrantyProposal(this.props.job.id, amendedData);
  }

  handleDeleteTechnicalWarrantyDecision = () => {
    this.closeDialog('amendTechnicalWarrantyDialog');
    this.props.actions.deleteApprovedTecnicalWarrantyProposal(this.props.job.id);
  }

  handleAmendCommercialDecisionConfirm = () => {
    const { amendCommercialDecisionDialog } = this.state;
    this.closeDialog('amendCommercialDecisionDialog');
    const amendedData = {
      category: amendCommercialDecisionDialog.category,
      decision: amendCommercialDecisionDialog.decision,
      reason: amendCommercialDecisionDialog.reason || null,
    };
    this.props.actions.amendCommercialDecision(
      this.props.job.id,
      amendedData,
    );
  }


  handleDeleteCommercialDecision = () => {
    this.closeDialog('amendCommercialDecisionDialog');
    this.props.actions.deleteCommercialDecision(this.props.job.id);
  }

  handleApproveAction = (actionType, proposalId, decision, reason) => {
    const action = camelCaseToDash(actionType);
    this.clearApproveTechnicalWarrantyReason();
    this.closeDialog('approveTechnicalWarrantyDialog');
    this.closeDialog('approveReportLevelDialog');
    this.closeDialog('approveReportStatusDialog');
    this.props.actions.approveAction(this.props.job.id, action, proposalId, decision, reason);
  }

  handleApproveComercialDecision = (actionType, proposalId, decision, reason) => {
    const action = camelCaseToDash(actionType);
    this.clearApproveCommercialDecisionReason();
    this.closeDialog('approveCommercialDecisionDialog');
    this.props.actions.approveCommercialDecisionAction(this.props.job.id, action, proposalId, decision, reason);
  }

  clearApproveTechnicalWarrantyReason = () => {
    this.setState({
      approveTechnicalWarrantyReason: '',
    })
  }

  clearApproveCommercialDecisionReason = () => {
    this.setState({
      approveCommercialDecisionReason: '',
    })
  }

  handleApproveActionClose = dialog => {
    this.setState({
      [dialog]: null,
    },
      this.clearApproveTechnicalWarrantyReason(),
      this.clearApproveCommercialDecisionReason(),
      () => this.closeDialog(dialog));
  }

  handleApproveTechnicalWarrantyReason = e => this.setState({ approveTechnicalWarrantyReason: e.target.value.trim() && e.target.value });

  handleApproveCommercialReason = e => this.setState({ approveCommercialDecisionReason: e.target.value.trim() && e.target.value });

  handleReclassifyTechnicalDecisionCategory = e => {
    this.setState(prevState =>
      ({ reclassifiedTechnicalDecision: { category: e.target.value, } }),
      () => {
        if (this.state.reclassifiedTechnicalDecision.serviceInformationBulletin
          && this.state.reclassifiedTechnicalDecision.category !== 'DESIGN') {
          const { category } = this.state.reclassifyTechnicalDecision;
          this.setState({ reclassifyTechnicalDecision: { category } })
        }
      }
    )
  }

  handleReclassifiedSIB = e => {
    e.persist();
    this.setState(prevState => ({
      reclassifiedTechnicalDecision: Object.assign(
        {},
        prevState.reclassifiedTechnicalDecision,
        { serviceInformationBulletin: e.target.value }
      )
    }))
  }

  handleReclassifyTechnicalDecisionCancel = () => {
    this.setState({
      reclassifyTechnicalWarrantyDialog: false,
      reclassifyTechnicalWarrantyCategory: {},
    })
  }

  handleReclassifyTechnicalDecisionConfirm = async () => {
    await this.props.actions.reclassifyTechnicalDecision(this.props.job.id, this.state.reclassifiedTechnicalDecision)
    this.handleReclassifyTechnicalDecisionCancel()
  }

  handleDateChange = name => date => this.setState({ [name]: moment(date).format() });

  handleWarrantyDateConfirm = warrantyType => {
    const date = warrantyType === warrantyTypes.START ? this.state.warrantyStartDate : this.state.warrantyEndDate;

    this.handleWarrantyDateCancel('warrantyStartDate', 'warrantyStartDialog');
    this.handleWarrantyDateCancel('warrantyEndDate', 'warrantyEndDialog');

    if (date && (this.state.warrantyStartDialog || this.state.warrantyEndDialog)) {
      this.props.actions.setWarrantyDate(this.props.job.id, warrantyType, date)
    }
  }

  handleRateTechnicalDecision = (jobId, requestId, data) => {
    this.props.actions.rateTechnicalDecision(jobId, requestId, data);
    this.closeDialog('rateTechnicalDecisionDialog');
  }

  handleCloseRateTechnicalDecisionDialog = () => {
    this.setState({ rateDecision: this.props.rateDecision, rateComment: this.props.rateComment });
    this.closeDialog('rateTechnicalDecisionDialog');
  }

  renderReportLevelDialog = (c, t, gt) => {
    const { reportLevelDialog, reportLevel, initialWarrantyCode } = this.state;
    const { job } = this.props;
    const initialWarrantyCodeOptions = this.props.initialWarrantyCodeOptions && this.props.initialWarrantyCodeOptions.map(
      a => (
        {
          'value': a.value,
          'label': a.value + ' / ' + a.description
        }
      )
    );

    return (
      <AlertDialog
        open={reportLevelDialog}
        handleClose={() => this.handleReportLevelCancel}
        title={t.reportLevelDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.proceed}
        handleCancel={this.handleReportLevelCancel}
        handleConfirm={this.handleReportLevelConfirm}
        confirmDisabled={reportLevel === job.reportLevel || (reportLevel > 1 && !initialWarrantyCode && job.manual)}
      >
        <DialogContentText>
          {t.reportLevelDialogContent}
        </DialogContentText>
        <RadioGroup
          aria-label="Set report level"
          name="set report level"
          onChange={this.handleSetReportLevel}
          value={reportLevel ? String(reportLevel) : String(this.props.job.reportLevel)}
          className={c.radioOptions}
        >
          {reportLevelOptions.map(option =>
            <Radio
              key={option.value}
              value={String(option.value)}
              disableRipple
              icon={<Chip label={option.label} className={c.radioButton} />}
              checkedIcon={<Chip label={option.label} className={c.radioButtonSelected} />}
            />
          )}
        </RadioGroup>
        {
          reportLevel > 1 && job.manual &&
          <FormControl className={c.formControl}>
            <InputLabel htmlFor="initialWarrantyCode">{t.initialWarrantyCode}</InputLabel>
            <Select
              id="initialWarrantyCode"
              hasNullOption={false}
              fullWidth
              disabled={false}
              value={initialWarrantyCode || ''}
              onChange={e => this.setState({ initialWarrantyCode: e.target.value })}
              options={initialWarrantyCodeOptions || []}
            />
          </FormControl>
        }
        <TextField
          className={c.textField}
          disabled={reportLevel === job.reportLevel || (reportLevel > 1 && !initialWarrantyCode && job.manual)}
          rows='4'
          multiline
          fullWidth
          label={t.changeReportLevelReason}
          margin='normal'
          variant='outlined'
          value={this.state.reportLevelReason}
          onChange={this.handleReportLevelReason}
        />
      </AlertDialog>
    )
  }


  renderApproveReportLevelDialog = (c, t, gt) => {
    const dialogData = this.state.approveReportLevelDialog;
    const { job } = this.props;

    return (dialogData &&
      <AlertDialog
        open={!!this.state.approveReportLevelDialog}
        title={t.approveReportLevelDialogTitle}
        onBackdropClick={() => this.handleApproveActionClose('approveReportLevelDialog')}
        cancelButtonText={gt.deny}
        confirmButtonText={gt.approve}
        handleCancel={() => this.handleApproveAction(jobActions.reportLevel, dialogData.id, 'DENIED')}
        handleConfirm={() => this.handleApproveAction(jobActions.reportLevel, dialogData.id, 'APPROVED')}
      >
        <Typography variant='body1'>{t.approveReportLevelDialogRequestedLevel}: {dialogData.level}</Typography>
        <Typography variant='body1'>{t.approveReportLevelDialogPreviousLevel}: {job.reportLevel}</Typography>
        {
          dialogData.level > 1 && job.manual &&
          <Typography variant='body1'>{t.approveReportLevelDialogInitialWarrantyCode}: {dialogData.initialWarrantyCode}</Typography>
        }
        <Typography variant='body1'>{gt.requestedBy}: {dialogData.requestedBy}</Typography>
        <Typography variant='body1'>{gt.requestedAt}:&nbsp;
          <time dateTime={dialogData.requestedAt}>
            {moment(dialogData.requestedAt).format(timeFormat.TIME)}
          </time>
        </Typography>
        {dialogData.reason && <Typography variant='body1'>{gt.reason}: {dialogData.reason}</Typography>}
      </AlertDialog>
    );
  }

  renderTechnicalWarrantyDialog = (c, t, gt) => {
    const { technicalWarranty, technicalWarrantyDialog } = this.state;

    return (
      <AlertDialog
        open={technicalWarrantyDialog}
        handleClose={() => this.closeDialog('technicalWarrantyDialog')}
        title={t.technicalWarrantyDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.proceed}
        confirmDisabled={
          !technicalWarranty.decision
          || !technicalWarranty.category
          || (technicalWarranty.category === 'DESIGN' && !technicalWarranty.serviceInformationBulletin)
          || (technicalWarranty.category === 'WARRANTY_EXPIRED' && !technicalWarranty.warrantyExpiredSubcategory)
        }
        handleCancel={() => this.handleWarrantyDecisionCancel(warrantyTypes.TECHNICAL_WARRANTY)}
        handleConfirm={() => this.handleWarrantyConfirm(warrantyTypes.TECHNICAL_WARRANTY)}
      >
        <FormControl className={c.formControl}>
          <DialogContentText>{t.technicalWarrantyDialogContent}</DialogContentText>
          <RadioGroup
            aria-label="Propose technical decision"
            name="propose technical decision"
            onChange={this.handleRadioSelect(warrantyTypes.TECHNICAL_WARRANTY)}
            value={technicalWarranty.decision || ''}
            className={c.radioOptions}
          >
            {technicalWarrantyDecisionOptions(gt.TechnicalWarranty).map(option =>
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            )}
          </RadioGroup>
        </FormControl>
        <FormControl className={c.formControl}>
          <InputLabel htmlFor="technicalWarrantyCategory">{t.technicalWarrantyDialogCategory}</InputLabel>
          <Select
            id="technicalWarrantyCategory"
            hasNullOption={false}
            fullWidth
            disabled={!technicalWarranty.decision}
            value={technicalWarranty.category || ''}
            onChange={this.handleWarrantyDecisionCategory(warrantyTypes.TECHNICAL_WARRANTY)}
            options={technicalWarranty.decision
              ? getTechnicalWarrantyOptions(technicalWarranty.decision, gt.TechnicalWarranty)
              : []
            }
          />
        </FormControl>
        {
          technicalWarranty.category === 'WARRANTY_EXPIRED' &&
          <FormControl className={c.formControl}>
            <InputLabel htmlFor="warrantyExpiredSubcategory">{t.warrantyExpiredSubcategoryLabel}</InputLabel>
            <Select
              id="warrantyExpiredSubcategory"
              hasNullOption={false}
              fullWidth
              value={technicalWarranty.warrantyExpiredSubcategory || ''}
              onChange={this.handleWarrantyExpiredSubcategory(warrantyTypes.TECHNICAL_WARRANTY)}
              options={getWarrantyExpiredSubcategoryOptions(gt.TechnicalWarranty)}
            />
          </FormControl>
        }
        {
          technicalWarranty.category === 'DESIGN' &&
          <TextField
            margin='normal'
            fullWidth
            label={t.technicalWarrantyDialogSIBFieldLabel}
            value={technicalWarranty.serviceInformationBulletin || ''}
            onChange={this.handleSIB(warrantyTypes.TECHNICAL_WARRANTY)}
            helperText={<span className={c.required}>{technicalWarranty.serviceInformationBulletin ? ' ' : gt.Forms.errors.required}</span>}
          />
        }
        <TextField
          className={c.textField}
          disabled={!technicalWarranty.decision || !technicalWarranty.category}
          rows='4'
          multiline
          fullWidth
          label={t.technicalDecisionReason}
          margin='normal'
          variant='outlined'
          value={technicalWarranty.reason || ''}
          onChange={this.handleReason(warrantyTypes.TECHNICAL_WARRANTY)}
        />
      </AlertDialog>
    )
  }

  renderEditTechnicalWarrantyDialog = (c, t, gt) => {
    const { editTechnicalWarrantyDialog: technicalWarranty } = this.state;

    return (
      <AlertDialog
        open={!!technicalWarranty}
        handleClose={() => this.closeDialog('editTechnicalWarrantyDialog')}
        title={t.editTechnicalWarrantyDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.save}
        confirmDisabled={
          !technicalWarranty.decision
          || !technicalWarranty.category
          || (technicalWarranty.category === 'DESIGN' && !technicalWarranty.serviceInformationBulletin)
          || (technicalWarranty.category === 'WARRANTY_EXPIRED' && !technicalWarranty.warrantyExpiredSubcategory)
        }
        handleCancel={() => this.closeDialog('editTechnicalWarrantyDialog')}
        handleConfirm={this.handleEditTechnicalWarrantyProposalConfirm}
        additionalActions={[{
          id: 1,
          onClick: this.handleDeleteTechnicalWarrantyProposal,
          text: gt.delete,
        }]}
      >
        <FormControl className={c.formControl}>
          <DialogContentText>{t.technicalWarrantyDialogContent}</DialogContentText>
          <RadioGroup
            aria-label="Edit technical decision proposal"
            name="edit technical decision proposal"
            onChange={this.handleRadioSelect(warrantyTypes.EDIT_TECHNICAL_WARRANTY)}
            value={technicalWarranty.decision || ''}
            className={c.radioOptions}
          >
            {technicalWarrantyDecisionOptions(gt.TechnicalWarranty).map(option =>
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            )}
          </RadioGroup>
        </FormControl>
        <FormControl className={c.formControl}>
          <InputLabel htmlFor="technicalWarrantyCategory">{t.technicalWarrantyDialogCategory}</InputLabel>
          <Select
            id="technicalWarrantyCategory"
            hasNullOption={false}
            fullWidth
            disabled={!technicalWarranty.decision}
            value={technicalWarranty.category || ''}
            onChange={this.handleWarrantyDecisionCategory(warrantyTypes.EDIT_TECHNICAL_WARRANTY)}
            options={technicalWarranty.decision
              ? getTechnicalWarrantyOptions(technicalWarranty.decision, gt.TechnicalWarranty)
              : []
            }
          />
        </FormControl>
        {
          (technicalWarranty.category === 'WARRANTY_EXPIRED' ||
           (technicalWarranty.category && technicalWarranty.category.startsWith('OUT_OF_STANDARD_WARRANTY_PERIOD_-_'))) &&
          <FormControl className={c.formControl}>
            <InputLabel htmlFor="warrantyExpiredSubcategory">{t.warrantyExpiredSubcategoryLabel}</InputLabel>
            <Select
              id="warrantyExpiredSubcategory"
              hasNullOption={false}
              fullWidth
              value={technicalWarranty.warrantyExpiredSubcategory || technicalWarranty.category || ''}
              onChange={this.handleWarrantyExpiredSubcategory(warrantyTypes.EDIT_TECHNICAL_WARRANTY)}
              options={getWarrantyExpiredSubcategoryOptions(gt.TechnicalWarranty)}
            />
          </FormControl>
        }
        {
          technicalWarranty.category === 'DESIGN' &&
          <TextField
            margin='normal'
            fullWidth
            label={t.technicalWarrantyDialogSIBFieldLabel}
            value={technicalWarranty.serviceInformationBulletin || ''}
            onChange={this.handleSIB(warrantyTypes.EDIT_TECHNICAL_WARRANTY)}
            helperText={<span className={c.required}>{technicalWarranty.serviceInformationBulletin ? ' ' : gt.Forms.errors.required}</span>}
          />
        }
        <TextField
          className={c.textField}
          disabled={!technicalWarranty.decision || !technicalWarranty.category}
          rows='4'
          multiline
          fullWidth
          label={t.technicalDecisionReason}
          margin='normal'
          variant='outlined'
          value={technicalWarranty.reason || ''}
          onChange={this.handleReason(warrantyTypes.EDIT_TECHNICAL_WARRANTY)}
        />
      </AlertDialog>
    )
  }

  renderAmendTechnicalWarrantyDialog = (c, t, gt) => {
    const { amendTechnicalWarrantyDialog: technicalWarranty } = this.state;
    return (
      <AlertDialog
        open={!!technicalWarranty}
        handleClose={() => this.closeDialog('amendTechnicalWarrantyDialog')}
        title={t.amendTechnicalWarrantyDecisionDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.save}
        confirmDisabled={
          !technicalWarranty.decision
          || !technicalWarranty.category
          || (technicalWarranty.category === 'DESIGN' && !technicalWarranty.serviceInformationBulletin)
          || (technicalWarranty.category === 'WARRANTY_EXPIRED' && !technicalWarranty.warrantyExpiredSubcategory)
        }
        handleCancel={() => this.closeDialog('amendTechnicalWarrantyDialog')}
        handleConfirm={this.handleAmendTechnicalWarrantyDecisionConfirm}
        additionalActions={[{
          id: 1,
          onClick: this.handleDeleteTechnicalWarrantyDecision,
          text: gt.delete,
        }]}
      >
        <FormControl className={c.formControl}>
          <DialogContentText>{t.technicalWarrantyDialogContent}</DialogContentText>
          <RadioGroup
            aria-label="Amend technical decision"
            name="amend technical decision"
            onChange={this.handleRadioSelect(warrantyTypes.AMEND_TECHNICAL_WARRANTY)}
            value={technicalWarranty.decision || ''}
            className={c.radioOptions}
          >
            {technicalWarrantyDecisionOptions(gt.TechnicalWarranty).map(option =>
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            )}
          </RadioGroup>
        </FormControl>
        <FormControl className={c.formControl}>
          <InputLabel htmlFor="technicalWarrantyCategory">{t.technicalWarrantyDialogCategory}</InputLabel>
          <Select
            id="technicalWarrantyCategory"
            hasNullOption={false}
            fullWidth
            disabled={!technicalWarranty.decision}
            value={technicalWarranty.category || ''}
            onChange={this.handleWarrantyDecisionCategory(warrantyTypes.AMEND_TECHNICAL_WARRANTY)}
            options={technicalWarranty.decision
              ? getTechnicalWarrantyOptions(technicalWarranty.decision, gt.TechnicalWarranty)
              : []
            }
          />
        </FormControl>
        {
          technicalWarranty.category === 'WARRANTY_EXPIRED' &&
          <FormControl className={c.formControl}>
            <InputLabel htmlFor="warrantyExpiredSubcategory">{t.warrantyExpiredSubcategoryLabel}</InputLabel>
            <Select
              id="warrantyExpiredSubcategory"
              hasNullOption={false}
              fullWidth
              value={technicalWarranty.warrantyExpiredSubcategory || ''}
              onChange={this.handleWarrantyExpiredSubcategory(warrantyTypes.AMEND_TECHNICAL_WARRANTY)}
              options={getWarrantyExpiredSubcategoryOptions(gt.TechnicalWarranty)}
            />
          </FormControl>
        }
        {
          technicalWarranty.category === 'DESIGN' &&
          <TextField
            margin='normal'
            fullWidth
            label={t.technicalWarrantyDialogSIBFieldLabel}
            value={technicalWarranty.serviceInformationBulletin || ''}
            onChange={this.handleSIB(warrantyTypes.AMEND_TECHNICAL_WARRANTY)}
            helperText={<span className={c.required}>{technicalWarranty.serviceInformationBulletin ? ' ' : gt.Forms.errors.required}</span>}
          />
        }
        <TextField
          className={c.textField}
          disabled={!technicalWarranty.decision || !technicalWarranty.category}
          rows='4'
          multiline
          fullWidth
          label={t.technicalDecisionReason}
          margin='normal'
          variant='outlined'
          value={technicalWarranty.reason || ''}
          onChange={this.handleReason(warrantyTypes.AMEND_TECHNICAL_WARRANTY)}
        />
      </AlertDialog>
    )
  }

  renderApproveTechnicalWarrantyDialog = (c, t, gt) => {
    const dialogData = this.state.approveTechnicalWarrantyDialog;
    const reason = this.state.approveTechnicalWarrantyReason;

    return (dialogData &&
      <AlertDialog
        open={!!dialogData}
        title={t.approveTechnicalWarrantyDialogTitle}
        onBackdropClick={() => this.handleApproveActionClose('approveTechnicalWarrantyDialog')}
        cancelButtonText={gt.deny}
        confirmButtonText={gt.approve}
        handleCancel={() => this.handleApproveAction(warrantyTypes.TECHNICAL_WARRANTY, dialogData.id, 'DENIED', reason)}
        handleConfirm={() => this.handleApproveAction(warrantyTypes.TECHNICAL_WARRANTY, dialogData.id, 'APPROVED', reason)}
      >
        {dialogData
          ? <Fragment>
            <Typography variant='body1'>{gt.proposedDecision}: <i>{gt.TechnicalWarranty[dialogData.decision]}</i></Typography>
            {
              // Check if category is one of the new WARRANTY_EXPIRED sub-categories
              dialogData.category && dialogData.category.startsWith('OUT_OF_STANDARD_WARRANTY_PERIOD_-_') ? (
                <Fragment>
                  <Typography variant='body1'>{gt.proposedCategory}: <i>{gt.TechnicalWarranty.WARRANTY_EXPIRED}</i></Typography>
                  <Typography variant='body1'>{gt.proposedSubcategory}: <i>{
                    // Map database value to enum key for translation
                    dialogData.category === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_NO_FAULT_FOUND' ? gt.TechnicalWarranty.WARRANTY_EXPIRED_NO_FAULT_FOUND :
                    dialogData.category === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_CUSTOMER_FAULT' ? gt.TechnicalWarranty.WARRANTY_EXPIRED_CUSTOMER_FAULT :
                    dialogData.category === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_OTHER' ? gt.TechnicalWarranty.WARRANTY_EXPIRED_OTHER :
                    dialogData.category === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_COMPONENT_ISSUE' ? gt.TechnicalWarranty.WARRANTY_EXPIRED_COMPONENT_ISSUE :
                    dialogData.category
                  }</i></Typography>
                </Fragment>
              ) : (
                <Typography variant='body1'>{gt.proposedCategory}: <i>{gt.TechnicalWarranty[dialogData.category]}</i></Typography>
              )
            }
            {
              dialogData.serviceInformationBulletin &&
              <Typography variant='body1'>{t.approveTechnicalWarrantyDialogSIBLabel}: <i>{dialogData.serviceInformationBulletin}</i></Typography>
            }
            <Typography variant='body1'>{gt.requestedBy}: {dialogData.requestedBy}</Typography>
            <Typography variant='body1'>{gt.requestedAt}:&nbsp;
              <time dateTime={dialogData.requestedAt}>
                {moment(dialogData.requestedAt).format(timeFormat.TIME)}
              </time>
            </Typography>
            {dialogData.reason && <Typography>{gt.reason}: <i>{dialogData.reason}</i></Typography>}
            <TextField
              className={c.textField}
              rows='4'
              multiline
              fullWidth
              label={`${t.decisionReason} - (${gt.optional})`}
              margin='normal'
              variant='outlined'
              value={reason}
              onChange={this.handleApproveTechnicalWarrantyReason}
            />
          </Fragment>
          : <Typography variant='body1'>Something went wrong...</Typography>
        }
      </AlertDialog>
    );
  }

  renderRateTechnicalDecisionDialog = (c, t, gt, job) => {
    const technicalWarranty = job && job.actions && job.actions.technicalWarranty;
    const approvedAction = technicalWarranty && technicalWarranty.find(action => action.status === 'APPROVED');
    const { rateDecision, rateComment } = this.state;

    return (
      <AlertDialog
        open={this.state.rateTechnicalDecisionDialog}
        handleClose={() => this.handleCloseRateTechnicalDecisionDialog()}
        title={t.rateTechnicalDecisionTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={t.rate}
        confirmDisabled={(rateDecision === 'Disagree' && !rateComment) || !rateDecision}
        handleCancel={() => this.handleCloseRateTechnicalDecisionDialog()}
        handleConfirm={() => this.handleRateTechnicalDecision(job.id, approvedAction.id, { rateDecision, rateComment })}
      >
        <FormControl className={c.formControl}>
          <RadioGroup
            aria-label="Rate technical decision"
            name="rate technical decision"
            onChange={e => this.setState({ rateDecision: e.target.value })}
            value={rateDecision || this.props.rateDecision || ''}
            className={c.radioOptions}
          >
            {technicalWarrantyRateOptions(gt.TechnicalWarranty).map(option =>
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            )}
          </RadioGroup>
        </FormControl>
        <TextField
          className={c.textField}
          rows='4'
          multiline
          fullWidth
          label={t.rateTechnicalDecisionComment}
          margin='normal'
          variant='outlined'
          value={rateComment || ''}
          onChange={e => this.setState({ rateComment: e.target.value })}
        />
      </AlertDialog>
    )
  }

  renderReclassifyTechnicalDecisionDialog = (c, t, gt, job) => {
    const { category, serviceInformationBulletin } = this.state.reclassifiedTechnicalDecision;
    const hasTechnicalDecision = job && job.actions && job.actions.technicalWarranty.length;
    const data = hasTechnicalDecision && job.actions.technicalWarranty.find(action => action.status === 'APPROVED');

    return (
      <AlertDialog
        open={this.state.reclassifyTechnicalWarrantyDialog}
        handleClose={() => this.closeDialog('reclassifyTechnicalWarrantyDialog')}
        title={t.reclassifyTechnicalWarrantyDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.proceed}
        confirmDisabled={
          !category
          || data.category === category
          || (category === 'DESIGN' && !serviceInformationBulletin)
        }
        handleCancel={this.handleReclassifyTechnicalDecisionCancel}
        handleConfirm={this.handleReclassifyTechnicalDecisionConfirm}
      >
        <FormControl className={c.formControl}>
          <DialogContentText>{t.technicalWarrantyDialogContent}</DialogContentText>
          <RadioGroup
            aria-label="Propose technical decision"
            name="propose technical decision"
            value={(data && data.decision) || ''}
            className={c.radioOptions}
          >
            {technicalWarrantyDecisionOptions(gt.TechnicalWarranty).map(option =>
              <FormControlLabel
                disabled
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            )}
          </RadioGroup>
        </FormControl>
        <FormControl className={c.formControl}>
          <InputLabel htmlFor="technicalWarrantyCategory">{t.technicalWarrantyDialogCategory}</InputLabel>
          <Select
            id="technicalWarrantyCategory"
            hasNullOption={false}
            fullWidth
            value={category || (data && data.category)}
            onChange={this.handleReclassifyTechnicalDecisionCategory}
            options={getReclassifableTechnicalWarrantyOptions(gt.TechnicalWarranty)}
          />
        </FormControl>
        {
          (category === 'DESIGN' || (!category && data && data.category === 'DESIGN')) &&
          <TextField
            margin='normal'
            fullWidth
            label={t.technicalWarrantyDialogSIBFieldLabel}
            value={serviceInformationBulletin || (!category && data && data.serviceInformationBulletin) || ''}
            onChange={this.handleReclassifiedSIB}
            helperText={<span className={c.required}>{serviceInformationBulletin ? ' ' : gt.Forms.errors.required}</span>}
          />
        }
        <TextField
          disabled
          className={c.textareaDisabled}
          rows='4'
          multiline
          fullWidth
          label={t.technicalDecisionReason}
          margin='normal'
          variant='outlined'
          value={(data && data.reason) || ''}
          onChange={this.handleReason(warrantyTypes.TECHNICAL_WARRANTY)}
        />
      </AlertDialog>
    )
  }

  renderCommercialDecisionDialog = (c, t, gt) =>
    <AlertDialog
      open={this.state.commercialDecisionDialog}
      handleClose={() => this.closeDialog('commercialDecisionDialog')}
      title={t.commercialDecisionDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.proceed}
      confirmDisabled={
        this.state.commercialDecision.decision !== 'CHARGEABLE_TO_CUSTOMER'
        && (!this.state.commercialDecision.decision || !this.state.commercialDecision.category)
      }
      handleCancel={() => this.handleWarrantyDecisionCancel(warrantyTypes.COMMERCIAL_DECISION)}
      handleConfirm={() => this.handleWarrantyConfirm(warrantyTypes.COMMERCIAL_DECISION)}
    >
      <FormControl className={c.formControl}>
        <DialogContentText>{t.commercialDecisionDialogContent}</DialogContentText>
        <RadioGroup
          aria-label="Propose commercial decision"
          name="propose commercial decision"
          onChange={this.handleRadioSelect(warrantyTypes.COMMERCIAL_DECISION)}
          value={this.state.commercialDecision.decision || ''}
          className={classNames(c.radioOptions, 'block')}
        >
          {commercialWarrantyDecisionOptions(gt.CommercialWarranty).map(option =>
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          )}
        </RadioGroup>
      </FormControl>
      <FormControl className={c.formControl}>
        <InputLabel htmlFor="commercialDecisionContent">{t.commercialDecisionDialogCategory}</InputLabel>
        <Select
          id="commercialDecisionContent"
          fullWidth
          disabled={
            !this.state.commercialDecision.decision
            || this.state.commercialDecision.decision === 'CHARGEABLE_TO_CUSTOMER'
          }
          value={this.state.commercialDecision.category || ''}
          onChange={this.handleWarrantyDecisionCategory(warrantyTypes.COMMERCIAL_DECISION)}
          options={this.state.commercialDecision.decision
            ? getCommercialWarrantyOptions(this.state.commercialDecision.decision, gt.CommercialWarranty)
            : []
          }
        />
      </FormControl>
      <TextField
        className={c.textField}
        rows='4'
        disabled={!this.state.commercialDecision.decision}
        multiline
        fullWidth
        label={t.commercialDecisionReason}
        margin='normal'
        variant='outlined'
        value={this.state.commercialDecision.reason || ''}
        onChange={this.handleReason(warrantyTypes.COMMERCIAL_DECISION)}
      />
    </AlertDialog>

  renderAmendCommercialDecisionDialog = (c, t, gt) => {
    const { amendCommercialDecisionDialog: commercialDecision } = this.state;
    return (
      <AlertDialog
        open={!!commercialDecision}
        handleClose={() => this.closeDialog('amendCommercialDecisionDialog')}
        title={t.amendCommercialDecisionDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.proceed}
        confirmDisabled={
          commercialDecision.decision !== 'CHARGEABLE_TO_CUSTOMER'
          && (!commercialDecision.decision || !commercialDecision.category)
        }
        handleCancel={() => this.closeDialog('amendCommercialDecisionDialog')}
        handleConfirm={this.handleAmendCommercialDecisionConfirm}
        additionalActions={[{
          id: 1,
          onClick: this.handleDeleteCommercialDecision,
          text: gt.delete,
        }]}
      >
        <FormControl className={c.formControl}>
          <DialogContentText>{t.commercialDecisionDialogContent}</DialogContentText>
          <RadioGroup
            aria-label="Amend commercial decision"
            name="amend commercial decision"
            onChange={this.handleRadioSelect(warrantyTypes.AMEND_COMMERCIAL_DECISION)}
            value={commercialDecision.decision || ''}
            className={classNames(c.radioOptions, 'block')}
          >
            {commercialWarrantyDecisionOptions(gt.CommercialWarranty).map(option =>
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            )}
          </RadioGroup>
        </FormControl>
        <FormControl className={c.formControl}>
          <InputLabel htmlFor="commercialDecisionContent">{t.commercialDecisionDialogCategory}</InputLabel>
          <Select
            id="commercialDecisionContent"
            fullWidth
            disabled={
              !commercialDecision.decision
              || commercialDecision.decision === 'CHARGEABLE_TO_CUSTOMER'
            }
            value={commercialDecision.category || ''}
            onChange={this.handleWarrantyDecisionCategory(warrantyTypes.AMEND_COMMERCIAL_DECISION)}
            options={commercialDecision.decision
              ? getCommercialWarrantyOptions(commercialDecision.decision, gt.CommercialWarranty)
              : []
            }
          />
        </FormControl>
        <TextField
          className={c.textField}
          rows='4'
          disabled={!commercialDecision.decision}
          multiline
          fullWidth
          label={t.commercialDecisionReason}
          margin='normal'
          variant='outlined'
          value={commercialDecision.reason || ''}
          onChange={this.handleReason(warrantyTypes.AMEND_COMMERCIAL_DECISION)}
        />
      </AlertDialog>
    );
  }

  renderApproveCommercialDecisionDialog = (c, t, gt) => {
    const { approveCommercialDecisionDialog: commercialDecision } = this.state;
    const reason = this.state.approveCommercialDecisionReason;

    return (
      <AlertDialog
        open={!!commercialDecision}
        title={t.approveCommercialDecisionDialogTitle}
        onBackdropClick={() => this.handleApproveActionClose('approveCommercialDecisionDialog')}
        cancelButtonText={gt.deny}
        confirmButtonText={gt.approve}
        handleCancel={() => this.handleApproveComercialDecision(warrantyTypes.COMMERCIAL_DECISION, commercialDecision.id, 'DENIED', reason)}
        handleConfirm={() => this.handleApproveComercialDecision(warrantyTypes.COMMERCIAL_DECISION, commercialDecision.id, 'APPROVED', reason)}
        additionalActions={[{
          id: 1,
          onClick: () => this.handleApproveActionClose('approveCommercialDecisionDialog'),
          text: gt.cancel,
        }]}
      >
        {commercialDecision
          ? <Fragment>
            {
              commercialDecision.serviceInformationBulletin &&
              <Typography variant='body1'>{t.approveTechnicalWarrantyDialogSIBLabel}: <i>{commercialDecision.serviceInformationBulletin}</i></Typography>
            }
            <Typography variant='body1'>{gt.requestedBy}: {commercialDecision.requestedBy}</Typography>
            <Typography variant='body1'>{gt.requestedAt}:&nbsp;
              <time dateTime={commercialDecision.requestedAt}>
                {moment(commercialDecision.requestedAt).format(timeFormat.TIME)}
              </time>
            </Typography>
            {commercialDecision.reason && <Typography>{gt.reason}: <i>{commercialDecision.reason}</i></Typography>}
            <TextField
              className={c.textField}
              rows='4'
              multiline
              fullWidth
              label={`${t.decisionReason} - (${gt.optional})`}
              margin='normal'
              variant='outlined'
              value={reason}
              onChange={this.handleApproveCommercialReason}
            />
          </Fragment>
          : <Typography variant='body1'>Something went wrong...</Typography>
        }
      </AlertDialog>
    );
  }

  handleReleaseMethodSelect = e => this.setState({ releaseMethod: e.target.value })

  handleEditChosenReleaseMethodSelect = e => this.setState({ chosenMethod: e.target.value })

  handleReleaseCancel = () => {
    this.setState(prevState =>
      ({ releaseMethod: '', shipToAddress: '', partNumbers: '', proposedDate: null })
    )
    this.closeDialog('releaseJobDialog')
  }

  handleEditChosenMethodCancel = () => {
    this.setState(prevState =>
      ({ chosenMethod: this.props.chosenMethod, shipToAddress: '', partNumbers: '', proposedDate: null })
    )
    this.closeDialog('editReleaseMethodDialog')
  }

  handleReleaseConfirm = () => {
    const { chosenMethod, chosenPartNumbers, chosenShipToAddress, chosenProposedDate } = this.state;
    const { id } = this.props.job;

    this.handleReleaseCancel();

    if (chosenMethod) {
      switch (chosenMethod) {
        case 'SEND_BACK_PARTS':
          return this.props.actions.setReleaseMethod(id, chosenMethod, null, chosenPartNumbers, chosenShipToAddress)
        case 'ON_SITE_PRESENCE':
          return this.props.actions.setReleaseMethod(id, chosenMethod, chosenProposedDate)
        default:
          return this.props.actions.setReleaseMethod(id, chosenMethod)
      }
    }
  }

  chooseReleaseMethod = () => {
    const { releaseMethod, partNumbers, shipToAddress, proposedDate } = this.state;
    const { id } = this.props.job;

    this.handleReleaseCancel();

    if (releaseMethod) {
      switch (releaseMethod) {
        case 'SEND_BACK_PARTS':
          try {
            return this.props.actions.chooseReleaseMethod(id, releaseMethod, null, partNumbers, shipToAddress)
          } finally {
            this.setState({ chosenMethod: releaseMethod, chosenPartNumbers: partNumbers, chosenShipToAddress: shipToAddress })
          }
        case 'ON_SITE_PRESENCE':
        case 'GOLDENEYE_UPLINK':
          try {
            return this.props.actions.chooseReleaseMethod(id, releaseMethod, proposedDate)
          } finally {
            this.setState({ chosenMethod: releaseMethod, chosenProposedDate: proposedDate })
          }
        default:
          try {
            return this.props.actions.chooseReleaseMethod(id, releaseMethod)
          } finally {
            this.setState({ chosenMethod: releaseMethod })
          }
      }
    }
  }

  editReleaseMethod = async () => {
    const { chosenMethod, chosenPartNumbers, chosenShipToAddress, chosenProposedDate } = this.state;
    const { id } = this.props.job;

    try {
      if (chosenMethod) {
        switch (chosenMethod) {
          case 'SEND_BACK_PARTS':
            try {
              return await this.props.actions.chooseReleaseMethod(id, chosenMethod, null, chosenPartNumbers, chosenShipToAddress)
            } finally {
              this.setState({ chosenProposedDate: null })
            }
          case 'ON_SITE_PRESENCE':
          case 'GOLDENEYE_UPLINK':
            try {
              return await this.props.actions.chooseReleaseMethod(id, chosenMethod, chosenProposedDate)
            } finally {
              this.setState({ chosenPartNumbers: null, chosenShipToAddress: null })
            }
          default:
            try {
              return await this.props.actions.chooseReleaseMethod(id, chosenMethod, null)
            } finally {
              this.setState({ chosenProposedDate: null, chosenPartNumbers: null, chosenShipToAddress: null })
            }
        }
      }
    } finally {
      this.handleEditChosenMethodCancel();
    }
  }

  renderReleaseJobDialog = (c, t, gt) =>
    <AlertDialog
      open={this.state.releaseJobDialog}
      handleClose={() => this.closeDialog('releaseJobDialog')}
      title={t.chooseReleaseJobMethodTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.choose}
      confirmDisabled={this.state.releaseMethod === 'ON_SITE_PRESENCE' || this.state.releaseMethod === 'GOLDENEYE_UPLINK'
        ? !this.state.releaseMethod || this.state.proposedDate === 'Invalid date' || moment(this.state.proposedDate).format() < moment(new Date(new Date().toDateString())).format()
        : !this.state.releaseMethod}
      handleCancel={this.handleReleaseCancel}
      handleConfirm={this.chooseReleaseMethod}
    >
      <FormControl className={c.formControl}>
        <DialogContentText>{t.releaseJobDialogLabel}</DialogContentText>
        <Select
          fullWidth
          value={this.state.releaseMethod || ''}
          onChange={this.handleReleaseMethodSelect}
          options={userHasRoles(this.props.user, ['SERVICE_TECHNICAL_SUPPORT_TEAM', 'PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM'])
            ? getReleaseMethodOptionsWithSendBackOption(gt.Release)
            : getReleaseMethodOptions(gt.Release)}
        />
        {(this.state.releaseMethod === 'ON_SITE_PRESENCE' || this.state.releaseMethod === 'GOLDENEYE_UPLINK') &&
          <div className={c.proposedDateDiv}>
            <DatePicker
              disablePast
              t={gt.DatePicker}
              placeholder={timeFormat.DATE.toLowerCase()}
              label={t.proposedDate}
              fullWidth
              value={this.state.proposedDate}
              onChange={this.handleDateChange('proposedDate')}
            />
          </div>
        }
        {this.state.releaseMethod === 'SEND_BACK_PARTS' &&
          <Fragment>
            <TextField
              margin='normal'
              fullWidth
              label={t.partNumbers}
              value={this.state.partNumbers}
              onChange={this.handleInput('partNumbers')}
            />
            <TextField
              className={c.textField}
              rows='2'
              multiline
              fullWidth
              label={t.shipToAddress}
              margin='normal'
              variant='outlined'
              value={this.state.shipToAddress}
              onChange={this.handleInput('shipToAddress')}
            />
          </Fragment>}
      </FormControl>
    </AlertDialog>

  renderEditReleaseMethodDialog = (c, t, gt) =>
    <AlertDialog
      open={this.state.editReleaseMethodDialog}
      handleClose={() => this.closeDialog('editReleaseMethodDialog')}
      title={t.editChosenReleaseJobMethodTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.save}
      confirmDisabled={this.state.chosenMethod === 'ON_SITE_PRESENCE'
        ? !this.state.chosenMethod || this.state.proposedDate === 'Invalid date' || moment(this.state.proposedDate).format() < moment(new Date(new Date().toDateString())).format()
        : !this.state.chosenMethod}
      handleCancel={this.handleEditChosenMethodCancel}
      handleConfirm={this.editReleaseMethod}
    >
      <FormControl className={c.formControl}>
        <DialogContentText>{t.releaseJobDialogLabel}</DialogContentText>
        <Select
          fullWidth
          value={this.state.chosenMethod || ''}
          onChange={this.handleEditChosenReleaseMethodSelect}
          options={userHasRoles(this.props.user, ['SERVICE_TECHNICAL_SUPPORT_TEAM', 'PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM'])
            ? getReleaseMethodOptionsWithSendBackOption(gt.Release)
            : getReleaseMethodOptions(gt.Release)}
        />
        {(this.state.chosenMethod === 'ON_SITE_PRESENCE' || this.state.chosenMethod === 'GOLDENEYE_UPLINK') &&
          <div className={c.proposedDateDiv}>
            <DatePicker
              disablePast
              t={gt.DatePicker}
              placeholder={timeFormat.DATE.toLowerCase()}
              label={t.proposedDate}
              fullWidth
              value={this.state.chosenProposedDate}
              onChange={this.handleDateChange('chosenProposedDate')}
            />
          </div>
        }
        {this.state.chosenMethod === 'SEND_BACK_PARTS' &&
          <Fragment>
            <TextField
              margin='normal'
              fullWidth
              label={t.partNumbers}
              value={this.state.chosenPartNumbers}
              onChange={this.handleInput('chosenPartNumbers')}
            />
            <TextField
              className={c.textField}
              rows='2'
              multiline
              fullWidth
              label={t.shipToAddress}
              margin='normal'
              variant='outlined'
              value={this.state.chosenShipToAddress}
              onChange={this.handleInput('chosenShipToAddress')}
            />
          </Fragment>}
      </FormControl>
    </AlertDialog>

  handleJobStatusChange = field => e => {
    const alreadyChangedStatus = this.state.jobStatus.find(status => status.status === field);

    if (alreadyChangedStatus) {
      this.setState(prevState => ({
        jobStatus: [
          ...prevState.jobStatus.filter(status => status.status !== field)
        ]
      }))
    }

    this.setState(prevState => ({
      jobStatus: [
        ...prevState.jobStatus,
        { status: field, value: e.target.value }
      ]
    }))
  }

  handleJobStatusCancel = () => {
    this.setState(
      { jobStatus: [] },
      () => this.closeDialog('editJobStatusDialog')
    );
  }

  handleJobStatusConfirm = () => {
    this.handleJobStatusCancel();

    if (this.state.jobStatus && this.state.jobStatus.length) {
      this.props.actions.setStatus(this.props.job.id, this.state.jobStatus)
    }
  }

  renderJobStatusDialog = (c, t, gt) =>
    <AlertDialog
      open={this.state.editJobStatusDialog}
      handleClose={() => this.closeDialog('editJobStatusDialog')}
      title={t.editJobStatusDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.proceed}
      handleCancel={this.handleJobStatusCancel}
      handleConfirm={this.handleJobStatusConfirm}
    >
      {statuses(gt.Status).map(st => {
        const updatedValue =
          this.state.jobStatus.find(status => status.status === st.value)
          && this.state.jobStatus.find(status => status.status === st.value).value

        return (
          <div key={st.label} className={c.editJobStatusFieldContainer}>
            <FormLabel htmlFor={st.value}>{st.label}</FormLabel>
            <Select
              id={st.value}
              fullWidth
              disabled={statusesThatCannotBeManuallySet.includes(st.value)}
              onChange={this.handleJobStatusChange(st.value)}
              value={updatedValue || (this.props.job.status && this.props.job.status[st.value])}
              options={getStatusOptions(st.value, gt)}
              hasNullOption={false}
            />
          </div>
        );
      })}
    </AlertDialog>

  handleSearchInput = key => e => this.setState({ [key]: e.target.value })

  handleTeamMemberSearch = () => {
    if (this.state.teamSearchQuery && this.state.teamSearchQuery.trim()) {
      this.props.actions.searchTeamMember(this.props.job.id, this.state.teamSearchQuery.trim());
    }
  }

  handleMemberSelection = id => () => {
    const { selectedTeamMembers } = this.state;
    const currentIndex = selectedTeamMembers.indexOf(id);
    const newChecked = [...selectedTeamMembers];

    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      selectedTeamMembers: newChecked,
    });
  }

  handleTeamDialogClose = () => {
    this.setState({
      teamSearchQuery: '',
      selectedTeamMembers: [],
    },
      () => this.closeDialog('teamDialog'));

    this.props.actions.clearTeamMemberSearch();
  }

  handleTeamDialogConfirm = () => {
    this.handleTeamDialogClose();
    this.props.actions.addTeamMember(this.props.job.id, this.state.selectedTeamMembers);
  }

  renderTeamDialog = (c, t, gt) =>
    <AlertDialog
      open={this.state.teamDialog}
      handleClose={this.handleTeamDialogClose}
      title={t.teamDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.assign}
      confirmDisabled={!this.state.selectedTeamMembers || (this.state.selectedTeamMembers && !this.state.selectedTeamMembers.length)}
      handleCancel={this.handleTeamDialogClose}
      handleConfirm={this.handleTeamDialogConfirm}
    >
      <Input
        value={this.state.teamSearchQuery}
        onChange={this.handleSearchInput('teamSearchQuery')}
        placeholder={gt.search}
      />
      <IconButton onClick={this.handleTeamMemberSearch}>
        <SearchIcon />
      </IconButton>

      <Collapse in={!!(this.props.searchedTeamMembers && this.props.searchedTeamMembers.length)}>
        {this.props.searchedTeamMembers && this.props.searchedTeamMembers.length
          ? <List className={c.teamMemberSearchResultsList}>
            {this.props.searchedTeamMembers.map(member => (
              <ListItem key={member.id} className={c.teamMemberSearchResult} dense button onClick={this.handleMemberSelection(member.id)}>
                <Checkbox
                  value=''
                  className={c.teamMemberSearchResultCheckbox}
                  checked={this.state.selectedTeamMembers.indexOf(member.id) !== -1}
                  tabIndex={-1}
                  disableRipple
                />
                <ListItemText className={c.teamMemberSearchResultText} primary={`${member.email} - ${member.firstName} ${member.lastName}`} />
              </ListItem>
            ))}
          </List>
          : this.props.searchedTeamMembers && !this.props.searchedTeamMembers.length ? gt.noResults : null
        }
      </Collapse>
      <Collapse in={!!this.props.searchedTeamMembers && !this.props.searchedTeamMembers.length}>
        {this.props.searchedTeamMembers && !this.props.searchedTeamMembers.length && <Typography variant='body1'>{gt.noResults}</Typography>}
      </Collapse>

    </AlertDialog>

  handleRemoveTeamMemberCancel = () => this.setState({ removeTeamMemberDialog: false })

  handleRemoveTeamMemberConfirm = userId => {
    this.handleRemoveTeamMemberCancel();
    this.props.actions.removeTeamMember(this.props.job.id, userId);
  }

  renderRemoveTeamMemberConfirmationDialog = (c, t, gt) => {
    const userId = this.state.removeTeamMemberDialog;

    return (
      <ConfirmationDialog
        open={!!this.state.removeTeamMemberDialog}
        title={t.removeTeamMemberDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.confirm}
        handleCancel={this.handleRemoveTeamMemberCancel}
        handleConfirm={() => this.handleRemoveTeamMemberConfirm(userId)}
      >
        <DialogContentText>{t.removeTeamMemberDialogContent}</DialogContentText>
      </ConfirmationDialog>
    )
  }

  handlePriceDialogClose = () => this.setState({ price: null }, () => this.closeDialog('editPriceDialog'));

  handlePriceDialogConfirm = () => {
    if (this.state.price && this.state.price >= 0) {
      this.handlePriceDialogClose();
      this.props.actions.setPrice(this.props.job.id, Number(this.state.price));
    }
  }

  renderPriceDialog = (c, t, gt) =>
    <AlertDialog
      maxWidth='xs'
      open={this.state.editPriceDialog}
      handleClose={this.handlePriceDialogClose}
      title={t.editPriceDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      handleCancel={this.handlePriceDialogClose}
      handleConfirm={this.handlePriceDialogConfirm}
      confirmDisabled={!this.state.price || this.state.price < 0}
    >
      <FormControl fullWidth className={c.margin}>
        <InputLabel shrink htmlFor="price">{t.editPriceLabel}</InputLabel>
        <Input
          id="price"
          type='number'
          inputProps={{ min: '0' }}
          value={this.state.price || ''}
          onChange={e => this.setState({ price: e.target.value })}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
        />
        {this.state.price < 0 && <span className={c.priceError}>{gt.Forms.errors.belowZero}</span>}
      </FormControl>
    </AlertDialog>

  handleReportStatusCancel = () => this.setState({ reportStatusDialog: false }, () => this.closeDialog('reportStatusDialog'));

  handleReportStatusConfirm = () => {
    this.handleReportStatusCancel();
    this.state.reportStatusDialog && this.props.actions.requestReportApproval(this.props.job.id);
  }

  handleEditInitialWarrantyCodeCancel = () => {
    this.setState({ initialWarrantyCode: this.props.job.initialWarrantyCode });
    this.closeDialog('changeInitialWarrantyCodeDialog');
  }

  handleEditInitialWarrantyCodeConfirm = async (jobId, initialWarrantyCode) => {
    await this.props.actions.editInitialWarrantyCode(jobId, { initialWarrantyCode });
    this.closeDialog('changeInitialWarrantyCodeDialog');
  }

  renderReportStatusDialog = (c, t, gt) =>
    <AlertDialog
      open={this.state.reportStatusDialog}
      handleClose={this.handleReportStatusCancel}
      title={t.reportStatusDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      handleCancel={this.handleReportStatusCancel}
      handleConfirm={this.handleReportStatusConfirm}
    >
      {t.reportStatusDialogContent}
      <p>
        <b>
          {t.reportStatusDialogMessage}
        </b>
      </p>
    </AlertDialog>

  renderApproveReportStatusDialog = (c, t, gt) => {
    const dialogData = this.state.approveReportStatusDialog;

    return (dialogData &&
      <AlertDialog
        open={!!dialogData}
        title={t.approveReportStatusDialogTitle}
        onBackdropClick={() => this.handleApproveActionClose('approveReportStatusDialog')}
        cancelButtonText={gt.deny}
        confirmButtonText={gt.approve}
        handleCancel={() => this.handleApproveAction(jobActions.APPROVE_REPORT, dialogData.id, 'DENIED')}
        handleConfirm={() => this.handleApproveAction(jobActions.APPROVE_REPORT, dialogData.id, 'APPROVED')}
      >
        {dialogData
          ? <Fragment>
            <Typography variant='body1'>{gt.requestedBy}: <i>{dialogData.requestedBy}</i></Typography>
            <Typography variant='body1'>{gt.requestedAt}:
              <span>&nbsp;</span>
              <i><time dateTime={dialogData.requestedAt}>
                {moment(dialogData.requestedAt).format(timeFormat.TIME)}
              </time></i>
            </Typography>
          </Fragment>
          : <Typography variant='body1'>{gt.errors.unknown}</Typography>
        }
      </AlertDialog>
    );
  }

  renderChangeInitialWarrantyCodeDialog = (c, t, gt) => {
    const { initialWarrantyCode, changeInitialWarrantyCodeDialog } = this.state;
    const initialWarrantyCodeOptions = this.props.initialWarrantyCodeOptions && this.props.initialWarrantyCodeOptions.map(
      a => (
        {
          'value': a.value,
          'label': a.value + ' / ' + a.description
        }
      )
    );

    return (
      <AlertDialog
        open={changeInitialWarrantyCodeDialog}
        handleClose={() => this.handleEditInitialWarrantyCodeCancel()}
        title={t.initialWarrantyCode}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.proceed}
        confirmDisabled={initialWarrantyCode === this.props.job.initialWarrantyCode}
        handleCancel={() => this.handleEditInitialWarrantyCodeCancel()}
        handleConfirm={() => this.handleEditInitialWarrantyCodeConfirm(this.props.job.id, initialWarrantyCode)}
      >
        <FormControl className={c.formControl}>
          <InputLabel htmlFor="initialWarrantyCode">{t.initialWarrantyCode}</InputLabel>
          <Select
            id="initialWarrantyCode"
            hasNullOption={false}
            fullWidth
            disabled={false}
            value={initialWarrantyCode || ''}
            onChange={e => this.setState({ initialWarrantyCode: e.target.value })}
            options={initialWarrantyCodeOptions || []}
          />
        </FormControl>
      </AlertDialog>
    )
  }

  handleReopenJobCancel = () =>
    this.setState(() =>
      ({ reopenJobDialog: false }),
      () => this.closeDialog('reopenJobDialog')
    )

  handleReopenJobConfirm = () => {
    this.handleReopenJobCancel();
    this.state.reopenJobDialog && this.props.actions.reopenJob(this.props.job.id);
  }

  renderReopenJobDialog = (c, t, gt) =>
    <ConfirmationDialog
      open={this.state.reopenJobDialog}
      handleClose={() => this.closeDialog('reopenJobDialog')}
      title={t.reportStatusDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.reopen}
      handleCancel={this.handleReopenJobCancel}
      handleConfirm={this.handleReopenJobConfirm}
    >
      {t.reportStatusDialogContent}
      <p>
        <b>
          {t.reportStatusDialogMessage}
        </b>
      </p>
    </ConfirmationDialog>

  handleEquipmentSerialNumber = async () => {
    this.closeDialog('editEquipmentSerialNumberDialog')

    if (this.state.equipmentSerialNumber
      && this.state.equipmentSerialNumber.trim()
      && this.state.equipmentSerialNumber.trim() !== this.props.job.equipmentSerialNumber
      && this.state.editEquipmentSerialNumberDialog
    ) {
      await this.props.actions.setEquipmentSerialNumber(this.props.job.id, this.state.equipmentSerialNumber.trim());
      this.handleEquipmentSerialNumberCancel();
    }
  }

  handleEquipmentSerialNumberCancel = () =>
    this.setState(() =>
      ({ equipmentSerialNumber: this.props.job.equipmentSerialNumber }),
      () => this.closeDialog('editEquipmentSerialNumberDialog')
    );

  renderEquipmentSerialNumberDialog = (c, t, gt) => {
    const { equipmentSerialNumber, editEquipmentSerialNumberDialog } = this.state;
    const hasError = !!['$', '#', '%'].find(specChar => equipmentSerialNumber && equipmentSerialNumber.includes(specChar));

    return (
      <AlertDialog
        open={editEquipmentSerialNumberDialog}
        handleClose={() => this.closeDialog('editEquipmentSerialNumberDialog')}
        title={t.editEquipmentSerialNumberDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.confirm}
        confirmDisabled={!equipmentSerialNumber || (equipmentSerialNumber && !equipmentSerialNumber.trim()) || hasError}
        handleCancel={this.handleEquipmentSerialNumberCancel}
        handleConfirm={this.handleEquipmentSerialNumber}
      >
        <TextField
          fullWidth
          className={c.equipmentSerialNumberField}
          error={hasError}
          helperText={hasError ? <span>{gt.Forms.errors.alphanumeric}</span> : ''}
          FormHelperTextProps={{ className: c.error }}
          type='text'
          label={t.editEquipmentSerialNumberDialogFieldLabel}
          onChange={this.handleInput('equipmentSerialNumber')}
          value={equipmentSerialNumber}
        />
      </AlertDialog>
    );
  }

  handleEditMaterialNumberClick = () => {
    this.openDialog('editMaterialNumberDialog');
  }

  handleMNSearch = () => {
    const { materialNumberSearchQuery } = this.state;

    if (materialNumberSearchQuery && materialNumberSearchQuery.trim()) {
      this.props.actions.getMaterialNumberOptions(this.props.job.serviceTechnologyCenterPlannerGroup + '/' + materialNumberSearchQuery.trim())
    }
  }

  handleEditMaterialNumberConfirm = async () => {
    this.closeDialog('editMaterialNumberDialog');

    if (this.state.materialNumber !== this.props.job.materialNumber
      && this.state.editMaterialNumberDialog
    ) {
      await this.props.actions.setMaterialNumber(this.props.job.id, this.state.materialNumber);
      this.handleEditMaterialNumberCancel();
    }
  }

  handleEditMaterialNumberCancel = () =>
    this.setState(() =>
    ({
      materialNumber: '',
      materialNumberSearchQuery: ''
    }),
      () => {
        this.props.actions.clearMaterialNumberOptions();
        this.closeDialog('editMaterialNumberDialog');
      }
    );

  renderMaterialNumberDialog = (c, t, gt) =>
    <AlertDialog
      open={this.state.editMaterialNumberDialog}
      handleClose={this.handleEditMaterialNumberCancel}
      title={t.editMaterialNumberDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      confirmDisabled={!this.state.materialNumber}
      handleCancel={this.handleEditMaterialNumberCancel}
      handleConfirm={this.handleEditMaterialNumberConfirm}
    >
      <Input
        value={this.state.materialNumberSearchQuery}
        onChange={this.handleSearchInput('materialNumberSearchQuery')}
        placeholder={gt.search}
      />
      <IconButton onClick={this.handleMNSearch}>
        <SearchIcon />
      </IconButton>

      <SuperSelect
        menuPortalTarget={document.getElementById('portal-for-SuperSelect')}
        className={c.editMaterialNumberSelect}
        styles={{ menuPortal: styles => ({ ...styles, zIndex: 10000 }) }}
        defaultValue={[]}
        isDisabled={!this.props.materialNumberOptions}
        value={this.state.materialNumber ? { 'label': this.state.materialNumber } : []}
        placeholder={t.editMaterialNumberDialogFieldLabel}
        options={this.props.materialNumberOptions || []}
        onChange={this.handleMaterialNumberSelect}
      />
    </AlertDialog>

  handleWarrantyDateCancel = (field, dialog) => {
    this.setState(
      { [field]: null },
      () => this.closeDialog(dialog)
    )
  }

  renderWarrantyStartDialog = (c, t, gt) => {
    const { equipmentWarrantyStartDate, equipmentWarrantyEndDate } = this.props.job;
    const { warrantyStartDate } = this.state;
    const currentValue = warrantyStartDate || equipmentWarrantyStartDate;
    const maxDate = equipmentWarrantyEndDate ? moment(equipmentWarrantyEndDate).subtract(1, 'days') : moment().add(100, 'years')
    const isValid = () => isValidDate(currentValue) && (isValidDate(warrantyStartDate) && Date.parse(warrantyStartDate) <= Date.parse(maxDate));

    return (
      <AlertDialog
        maxWidth='xs'
        open={this.state.warrantyStartDialog}
        title={t.warrantyStartDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.confirm}
        handleCancel={() => this.handleWarrantyDateCancel(warrantyTypes.START_DATE, 'warrantyStartDialog')}
        handleConfirm={() => this.handleWarrantyDateConfirm(warrantyTypes.START)}
        confirmDisabled={!isValid() || !currentValue || isSameDate(warrantyStartDate, equipmentWarrantyStartDate)}
      >
        <DatePicker
          fullWidth
          maxDate={equipmentWarrantyEndDate
            ? moment(equipmentWarrantyEndDate).subtract(1, 'days')
            : moment().add(100, 'years')}
          label={t.warrantyStartDateLabel}
          value={currentValue}
          onChange={this.handleDateChange(warrantyTypes.START_DATE)}
          t={gt.DatePicker}
        />
      </AlertDialog>
    );
  }

  renderWarrantyEndDialog = (c, t, gt) => {
    const { equipmentWarrantyStartDate, equipmentWarrantyEndDate } = this.props.job;
    const { warrantyEndDate } = this.state;
    const currentValue = warrantyEndDate || equipmentWarrantyEndDate;
    const minDate = equipmentWarrantyStartDate ? moment(equipmentWarrantyStartDate).add(1, 'days') : '01-01-1900';
    const isValid = () => isValidDate(currentValue) && (isValidDate(warrantyEndDate) && Date.parse(warrantyEndDate) >= Date.parse(minDate));

    return (
      <AlertDialog
        maxWidth='xs'
        open={this.state.warrantyEndDialog}
        title={t.warrantyEndDialogTitle}
        cancelButtonText={gt.cancel}
        confirmButtonText={gt.confirm}
        handleCancel={() => this.handleWarrantyDateCancel(warrantyTypes.END_DATE, 'warrantyEndDialog')}
        handleConfirm={() => this.handleWarrantyDateConfirm(warrantyTypes.END)}
        confirmDisabled={!isValid() || !currentValue || isSameDate(warrantyEndDate, equipmentWarrantyEndDate)}
      >
        <DatePicker
          fullWidth
          minDate={minDate}
          label={t.warrantyEndDateLabel}
          value={currentValue}
          onChange={this.handleDateChange(warrantyTypes.END_DATE)}
          t={gt.DatePicker}
        />
      </AlertDialog>
    );
  }

  handleVerifyJobCancel = () => {
    this.setState(() =>
      ({ verifyJobDialog: false }),
      () => this.closeDialog('verifyJobDialog')
    );
  }

  verifyJob = () => {
    this.handleVerifyJobCancel();
    this.state.verifyJobDialog && this.props.actions.verifyJob(this.props.job.id);
  }

  renderVerifyJobDialog = (c, t, gt) =>
    <ConfirmationDialog
      confirmDisabled={!(this.props.job.equipmentSerialNumber && this.props.job.materialNumber)}
      open={this.state.verifyJobDialog}
      title={t.verifyJobDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      handleCancel={this.handleVerifyJobCancel}
      handleConfirm={this.verifyJob}
    >
      <div>{t.verifyJobDialogContent}</div>
      <p>{t.materialNumber}: {this.props.job.materialNumber || gt.noInfo}</p>
      <p>{t.equipmentSerialNumber}: {this.props.job.equipmentSerialNumber || <Typography color='error'>{t.serialNumberMissingPleaseAdd}</Typography>}</p>
    </ConfirmationDialog>

  handleDeleteJobCancel = () => {
    this.closeDialog('deleteConfirmationDialog')
  }

  handleDeleteImportedJobCancel = () => {
    this.closeDialog('deleteImportedJobConfirmationDialog');
  }

  deleteJob = () => {
    this.handleDeleteJobCancel();
    this.props.job && this.props.actions.deleteJob(this.props.job.id);
  }

  deleteImportedJob = () => {
    this.handleDeleteImportedJobCancel();
    this.props.job && this.props.actions.deleteImportedJob(this.props.job.id);
  }

  renderDeleteConfirmationDialog = (c, t, gt) =>
    <ConfirmationDialog
      open={this.state.deleteConfirmationDialog}
      title={t.deleteConfirmationDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      handleCancel={this.handleDeleteJobCancel}
      handleConfirm={this.deleteJob}
    >
      <DialogContentText>{t.deleteConfirmationDialogContent}</DialogContentText>
    </ConfirmationDialog>

  renderDeleteImportedJobConfirmationDialog = (c, t, gt) =>
    <ConfirmationDialog
      open={this.state.deleteImportedJobConfirmationDialog}
      title={t.deleteConfirmationDialogTitle}
      cancelButtonText={gt.cancel}
      confirmButtonText={gt.confirm}
      handleCancel={this.handleDeleteImportedJobCancel}
      handleConfirm={this.deleteImportedJob}
    >
      <DialogContentText>{t.deleteImportedJobConfirmationDialogContent}</DialogContentText>
    </ConfirmationDialog>

  renderTechnicalDecisionInfo = (c, t, gt, job) => {
    const tsl = gt.TechnicalWarranty;
    const hasTechnicalDecision = job && job.actions && job.actions.technicalWarranty.length;
    const approvedAction = hasTechnicalDecision && job.actions.technicalWarranty.find(action => action.status === 'APPROVED');
    const decision = approvedAction && approvedAction.decision;
    const category = approvedAction && approvedAction.category;
    const userCanReclassify = userHasRoles(this.props.user, rolesThatCanReclassify);
    const canBeReclassified = approvedAction && reclassifiableCategories.includes(approvedAction.category) && userCanReclassify;

    // Map database category value to enum key for translation
    const getCategoryTranslationKey = (categoryValue) => {
      if (!categoryValue) return categoryValue;
      // Map new sub-categories from database value to enum key
      if (categoryValue === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_NO_FAULT_FOUND') return 'WARRANTY_EXPIRED_NO_FAULT_FOUND';
      if (categoryValue === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_CUSTOMER_FAULT') return 'WARRANTY_EXPIRED_CUSTOMER_FAULT';
      if (categoryValue === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_OTHER') return 'WARRANTY_EXPIRED_OTHER';
      if (categoryValue === 'OUT_OF_STANDARD_WARRANTY_PERIOD_-_COMPONENT_ISSUE') return 'WARRANTY_EXPIRED_COMPONENT_ISSUE';
      // For other categories, use the value directly (it should match enum key)
      return categoryValue;
    };

    const categoryKey = getCategoryTranslationKey(category);
    const categoryLabel = tsl[categoryKey] || category;

    if (canBeReclassified) {
      return <Grid item xs={8} sm={5}><Typography variant='body1'>{`${tsl[decision]} - ${categoryLabel}`}</Typography></Grid>
    } else if (approvedAction) {
      return <Grid item xs={8} sm={5}><Typography variant='body1'>{`${tsl[decision]} - ${categoryLabel}`}</Typography></Grid>
    } else {
      return <Grid item xs={8} sm={5}><Typography variant='body1'>{gt.noInfo}</Typography></Grid>
    }
  }

  renderTechnicalWarrantyAction = (c, t, gt) => {
    const { job, user } = this.props;
    const technicalWarranty = job && job.actions && job.actions.technicalWarranty;
    const commercialDecision = job && job.actions && job.actions.commercialDecision;
    const approvedAction = technicalWarranty && technicalWarranty.find(action => action.status === 'APPROVED');
    const showRateButton = new Date(this.props.rateVisibilityDateTo).getTime() > (new Date().getTime());

    if (isPending(technicalWarranty) && !job.locked) {
      if (
        userHasPermissionWithId(
          user,
          job.reportLevel === 4 ? permissions.APPROVE_TECHNICAL_DECISION_LEVEL_4 : permissions.WARRANTY_DECISION,
          getPotentialResponders(technicalWarranty)
        )
      ) {
        if (userIsActionRequester(user, isPending(technicalWarranty)) && userHasPermission(user, permissions.REQUEST_TECHNICAL_WARRANTY_DECISION)) {
          return (
            <Grid item xs={4} sm={2} className={c.fieldAction}>
              <Button
                disableRipple variant='text' color='secondary'
                onClick={() => this.openDialogWithData('approveTechnicalWarrantyDialog', isPending(technicalWarranty))}
                className={c.editButton}
              >
                {`(${gt.pending})`}
              </Button>
              <Button
                disableRipple variant='text' color='secondary' className={c.editButton}
                onClick={() => this.openDialogWithData('editTechnicalWarrantyDialog', isPending(technicalWarranty))}>{`(${gt.editProposal})`}</Button>
            </Grid>
          );
        } else {
          return (
            <Grid item xs={4} sm={2} className={c.fieldAction}>
              <Button
                disableRipple variant='text' color='secondary'
                onClick={() => this.openDialogWithData('approveTechnicalWarrantyDialog', isPending(technicalWarranty))}
                className={c.editButton}
              >
                {gt.pending}
              </Button>
            </Grid>
          )
        }
      } else if (userIsActionRequester(user, isPending(technicalWarranty)) && userHasPermission(user, permissions.REQUEST_TECHNICAL_WARRANTY_DECISION)) {
        return (
          <Grid item xs={4} sm={2} className={c.fieldAction}>
            <Button
              disableRipple variant='text' color='secondary' className={c.editButton}
              onClick={() => this.openDialogWithData('editTechnicalWarrantyDialog', isPending(technicalWarranty))}>{gt.editProposal}</Button>
          </Grid>
        );
      } else {
        return <Grid item xs={4} sm={2} className={c.fieldAction}><Typography variant='body1'><i>{gt.pending}</i></Typography></Grid>
      }
    } else if (!approvedAction && userHasPermission(user, permissions.REQUEST_TECHNICAL_WARRANTY_DECISION) && !job.locked) {
      return (
        <Grid item xs={4} sm={2} className={c.fieldAction}>
          <Button
            disableRipple variant='text' color='secondary'
            onClick={() => this.openDialog('technicalWarrantyDialog')}
            className={c.editButton}
          >
            {gt.edit}
          </Button>
        </Grid>
      );
    } else if (approvedAction) {
      let renderButtons = [];
      if (
        userHasPermission(user, permissions.AMEND_APPROVED_TECHNICAL_DECISION)
        && !isApproved(commercialDecision)
      ) {
        renderButtons.push(
          <Button
            key={1}
            disableRipple variant='text' color='secondary' className={c.editButton}
            onClick={() => this.openDialogWithData('amendTechnicalWarrantyDialog', isApproved(technicalWarranty))}
          >
            {`(${gt.amend})`}
          </Button>
        );
      } else if (userHasPermission(user, permissions.RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY)) {
        renderButtons.push(
          <Button
            key={2}
            disableRipple variant='text' color='secondary'
            onClick={() => this.openDialog('reclassifyTechnicalWarrantyDialog')}
            className={c.editButton}
          >
            {`(${t.reclassify})`}
          </Button>
        );
      }
      if (showRateButton) {
        renderButtons.push(
          <Button
            key={3}
            disableRipple variant='text' color='secondary'
            onClick={() => this.openDialog('rateTechnicalDecisionDialog')}
            className={classNames(c.editButton)}
          >
            {`(${t.rate})`}
          </Button>
        );
      }
      return renderButtons.length > 0
        ? <Grid item xs={4} sm={2} className={c.fieldAction}>{renderButtons}</Grid>
        : null;
    } else {
      return null;
    }
  }

  renderCommercialDecisionInfo = (c, t, gt, job) => {
    const { user } = this.props
    const tsl = gt.CommercialWarranty;
    const commercialDecisions = job && job.actions && job.actions.commercialDecision ? [...job.actions.commercialDecision].sort((a, b) => {
      if (a.id == null && b.id == null) return 0;
      if (a.id == null) return 1;
      if (b.id == null) return -1;
      return a.id - b.id;
    }) : [];
    const hasCommercialDecision = commercialDecisions.length > 0;
    const commercialDecision = hasCommercialDecision ? commercialDecisions[commercialDecisions.length - 1] : null;
    const hasDisplayableCommercialDecision = hasCommercialDecision && commercialDecision.status !== 'DENIED';
    const { decision, category } = commercialDecision || {};
    if (hasDisplayableCommercialDecision) {
      const categoryLabel = category ? (tsl[category] || category) : '';
      const displayInfo = categoryLabel ? `${tsl[decision]} - ${categoryLabel}` : `${tsl[decision]}`;

      return (
        <Fragment>
          <Grid item xs={8} sm={5}><Typography variant='body1'>{displayInfo}</Typography></Grid>
          <Grid item xs={4} sm={2} className={c.fieldAction}>
            {commercialDecision.status === 'PENDING' && userHasPermission(user, permissions.GOODWILL_DECISION) &&
              <Button disableRipple onClick={() => this.openDialogWithData('approveCommercialDecisionDialog', commercialDecision)} className={c.editButton} variant='text' color='secondary'>({gt.pending})</Button>
            }
            {commercialDecision.status === 'APPROVED' && userHasPermission(user, permissions.AMEND_APPROVED_COMMERCIAL_DECISION) &&
              <Button disableRipple onClick={() => this.openDialogWithData('amendCommercialDecisionDialog', commercialDecision)} className={c.editButton} variant='text' color='secondary'>({gt.editProposal})</Button>
            }
          </Grid>
        </Fragment>
      )
    } else if (job.actions && isTechnicalDecisionDeclined(job.actions.technicalWarranty)
      && (job.price || job.price === 0) && userHasPermission(this.props.user, permissions.GOODWILL_DECISION)
      && !hasDisplayableCommercialDecision
    ) {
      return (
        <Fragment>
          <Grid item xs={8} sm={5}><Typography variant='body1'>{gt.noInfo}</Typography></Grid>
          <Grid item xs={4} sm={2} className={c.fieldAction}>
            <Button disableRipple onClick={() => this.openDialog('commercialDecisionDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
          </Grid>
        </Fragment>
      );
    } else {
      return <Grid item xs={12} sm={7}><Typography variant='body1'>{gt.noInfo}</Typography></Grid>
    }
  }

  renderReportStatusAction = (c, t, gt) => {
    const { job, user } = this.props;
    const { reportLevel } = job;
    const reportStatus = job.actions && job.actions.approveReport;

    if (isPending(reportStatus)) {
      if (userHasReportPermissionWithId(user, reportLevel, getPotentialResponders(reportStatus))) {
        return <Button disableRipple onClick={() => this.openDialogWithData('approveReportStatusDialog', isPending(reportStatus))} className={c.editButton} variant='text' color='secondary'>{gt.pending}</Button>
      } else {
        return <Typography variant='body1'><i>{gt.pending}</i></Typography>
      }
    } else if (
      userHasPermission(this.props.user, permissions.EDIT_JOB)
      && (!isLastActionApproved(job.actions, jobActions.APPROVE_REPORT)
        || (!job.locked && isLastActionApproved(job.actions, jobActions.APPROVE_REPORT) && isLastActionApproved(job.actions, jobActions.REOPEN_REPORT)))
    ) {
      return <Button disableRipple onClick={() => this.openDialog('reportStatusDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
    } else if (isLastActionApproved(job.actions, jobActions.APPROVE_REPORT) && userHasReopenReportPermission(user, reportLevel)) {
      return <Button disableRipple onClick={() => this.openDialog('reopenJobDialog')} className={c.editButton} variant='text' color='secondary'>{gt.reopen}</Button>
    }

    return null;
  }

  render() {
    const {
      classes: c,
      t,
      gt,
      job,
      user,
    } = this.props;
    const gtFields = gt.Forms.fields;
    const gtCodes = gt.FaultCodes;
    const steps = job.id ? getJobProgress(job.progress, gt.Progress) : [];
    const statusSteps = job.id ? getJobStatus(job.status, gt.Status) : [];
    const jobReleased = job && job.status && job.status.jobReleased === 'FULFILLED';
    const shouldBeClosed = job && job.reportLevel > 1 && !job.stcHasTechnicalPossibility;
    const timeCreated = job.jobDate ? moment(job.jobDate).format(timeFormat.MINUTES) : gt.noInfo;
    const timeModified = job.jobLastModifiedDate ? moment(job.jobLastModifiedDate).format(timeFormat.MINUTES) : timeCreated;
    return (
      <Paper component='main' className={classNames(c.jobSummary, shouldBeClosed ? 'closed' : '')}>
        {
          job.id ?
            <Fragment>

              <header className={c.jobSummaryHeader}>
                <Typography variant='h6'>{t.title}</Typography>
                {
                  job.manual && !job.verified && !job.locked && userHasPermission(user, permissions.DELETE_JOB) &&
                  <Button
                    disableRipple
                    className={c.deleteButton}
                    onClick={() => this.openDialog('deleteConfirmationDialog')}
                  >
                    <DeleteIcon className={c.deleteIcon} /> {gt.delete}
                  </Button>
                }
                {
                  !job.manual && userHasPermission(user, permissions.DELETE_IMPORTED_SAP_JOB) &&
                  <Button
                    disableRipple
                    className={c.deleteButton}
                    onClick={() => this.openDialog('deleteImportedJobConfirmationDialog')}
                  >
                    <DeleteIcon className={c.deleteIcon} /> {t.deleteImportedJob}
                  </Button>
                }
              </header>

              <Grid container spacing={4}>
                <Grid item xs={12} lg={6}>
                  <section className={c.outlinedSection}>
                    <header><Typography variant='subtitle2'>{gtFields.basicInformation}</Typography></header>
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{t.createdAt}</i></Typography></Grid>
                      <Grid item xs={12} sm={6} lg={6}><Typography variant='body1'>{timeCreated}</Typography></Grid>
                    </Grid>
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{t.modifiedAt}</i></Typography></Grid>
                      <Grid item xs={12} sm={6} lg={6}><Typography variant='body1'>{timeModified}</Typography></Grid>
                    </Grid>
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.customerCenter}</i></Typography></Grid>
                      <Grid item xs={3} sm={2}><Typography variant='body1'>{job.customerCenterPlantCode}</Typography></Grid>
                      <Grid item xs={9} sm={5}><Typography variant='body1'>{job.customerCenterName}</Typography></Grid>
                    </Grid>
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.serviceTechnologyCenter}</i></Typography></Grid>
                      <Grid item xs={3} sm={2}><Typography variant='body1'>{job.serviceTechnologyCenterPlannerGroup}</Typography></Grid>
                      <Grid item xs={9} sm={5}><Typography variant='body1'>{job.serviceTechnologyCenterName}</Typography></Grid>
                    </Grid>
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.reportLevel}</i></Typography></Grid>
                      <Grid item xs={8} sm={5}><Typography variant='body1'>{job.reportLevel}</Typography></Grid>
                      {
                        !job.locked &&
                        <Grid item xs={4} sm={2} className={c.fieldAction}>
                          {
                            job.actions && isPending(job.actions.reportLevel)
                              ? userHasPermissionWithId(user, job.reportLevel === 4 ? permissions.APPROVE_REPORT_LEVEL_4_DOWNGRADE : permissions.APPROVE_DIFFERENT_REPORT_LEVEL, getPotentialResponders(job.actions.reportLevel))
                                ? <Button disableRipple onClick={() => this.openDialogWithData('approveReportLevelDialog', isPending(job.actions.reportLevel))} className={c.editButton} variant='text' color='secondary'>{gt.pending}</Button>
                                : <Typography variant='body1'><i>{gt.pending}</i></Typography>
                              : userHasPermission(user, permissions.REQUEST_DIFFERENT_REPORT_LEVEL) &&
                              <Button disableRipple onClick={() => this.openDialogWithInitialWarrantyCodesAPICall('reportLevelDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
                          }
                        </Grid>
                      }
                    </Grid>
                    {
                      job.reportLevel > 1 &&
                      <Grid container className={c.field}>
                        <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.initialWarrantyCode}</i></Typography></Grid>
                        <Grid item xs={8} sm={5}><Typography variant='body1'>{job.initialWarrantyCode || gt.noInfo}</Typography></Grid>
                        {
                          userHasPermission(user, permissions.ADD_INITIAL_WARRANTY_CODE) &&
                          <Grid item xs={4} sm={2} className={c.fieldAction}>
                            <Button disableRipple onClick={() => this.openDialogWithInitialWarrantyCodesAPICall('changeInitialWarrantyCodeDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
                          </Grid>
                        }
                      </Grid>
                    }
                    {
                      job.reportLevel > 1 && job.initialWarrantyCode &&
                      <Grid container className={c.field}>
                        <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.technicalDecision}</i></Typography></Grid>
                        {this.renderTechnicalDecisionInfo(c, t, gt, job)}
                        {this.renderTechnicalWarrantyAction(c, t, gt)}
                      </Grid>
                    }
                    {
                      job.reportLevel > 1 && job.initialWarrantyCode &&
                      <Grid container className={c.field}>
                        <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.commercialDecision}</i></Typography></Grid>
                        {this.renderCommercialDecisionInfo(c, t, gt, job)}
                      </Grid>
                    }
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.price}</i></Typography></Grid>
                      <Grid item xs={8} sm={5}><Typography variant='body1'>{job.price != null ? `$${job.price}` : gt.noInfo}</Typography></Grid>
                      {
                        !job.locked && job.manual && job.status && job.status.closed === 'FULFILLED' && userHasPermission(user, permissions.CREATE_JOB) &&
                        <Grid item xs={4} sm={2} className={c.fieldAction}>
                          <Button disableRipple onClick={() => this.openDialog('editPriceDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
                        </Grid>
                      }
                    </Grid>
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.customerPurchaseOrderNumber}</i></Typography></Grid>
                      <Grid item xs={12} sm={7}><Typography variant='body1'>{job.customerPurchaseOrderNumber || gt.noInfo}</Typography></Grid>
                    </Grid>
                    <Grid container className={c.field}>
                      <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.reportStatus}</i></Typography></Grid>
                      <Grid item xs={8} sm={5}><Typography variant='body1'>{isLastActionApproved(job.actions, jobActions.APPROVE_REPORT) && job.locked ? gt.approved : gt.notApproved}</Typography></Grid>
                      <Grid item xs={4} sm={2} className={c.fieldAction}>
                        {this.renderReportStatusAction(c, t, gt)}
                      </Grid>
                    </Grid>
                    {
                      job.reportLevel > 2 &&
                      <Grid container className={classNames(c.field, c.releaseJobField)}>
                        <Grid item xs={12} sm={5}><Typography variant='body1'><i>{gtFields.releaseJob}</i></Typography></Grid>
                        <Grid item xs={jobReleased ? 12 : 8} sm={jobReleased ? 7 : 5}>
                          <Typography variant='body1'>
                            {jobReleased
                              ? `${gt.released} - ${gt.Release[job.releaseMethod]} ${(job.proposedDate && job.proposedDate !== 'Invalid date')
                                ? ` (${moment(job.proposedDate).format(timeFormat.DATE)})`
                                : ''}`
                              : this.props.chosenMethod
                                ? `${t.chosenMethod} - ${gt.Release[this.props.chosenMethod]} ${(this.props.chosenProposedDate && this.props.chosenProposedDate !== 'Invalid date' && (this.props.chosenMethod === 'ON_SITE_PRESENCE' || this.props.chosenMethod === 'GOLDENEYE_UPLINK'))
                                  ? ` (${moment(this.props.chosenProposedDate).format(timeFormat.DATE)})`
                                  : ''}`
                                : gt.notReleased}
                          </Typography>
                        </Grid>
                        {
                          !job.locked && !jobReleased && userHasReleasePermission(user, job.reportLevel) &&
                          <Grid item xs={4} sm={2} className={c.fieldAction}>
                            {this.props.chosenMethod
                              ? <Fragment>
                                <Button
                                  disableRipple variant='text' color='secondary'
                                  onClick={() => this.openDialog('editReleaseMethodDialog')}
                                  className={c.editButton}
                                >
                                  {gt.edit}
                                </Button>
                                <br />
                                <Button
                                  disableRipple variant='text' color='secondary'
                                  onClick={() => this.handleReleaseConfirm()}
                                  className={c.editButton}
                                >
                                  {gt.release}
                                </Button>
                              </Fragment>
                              : <Button
                                disableRipple variant='text' color='secondary'
                                onClick={() => this.openDialog('releaseJobDialog')}
                                className={c.editButton}
                              >
                                {t.chooseMethod}
                              </Button>
                            }
                          </Grid>
                        }
                      </Grid>
                    }
                  </section>

                  <section>
                    <Grid container>
                      <Grid item xs={10}>
                        <header><Typography variant='subtitle2'>{gtFields.jobStatus}</Typography></header>
                      </Grid>
                      {
                        !job.locked && job.manual && userHasPermission(user, permissions.EDIT_JOB) &&
                        <Grid item xs={2} className={c.fieldActionNotOutlined}>
                          <Button disableRipple onClick={() => this.openDialog('editJobStatusDialog')} className={classNames(c.editButton, 'jobStatus')} variant='text' color='secondary'>{gt.edit}</Button>
                        </Grid>
                      }
                    </Grid>
                    <MultiStepper
                      orientation='vertical'
                      steps={statusSteps}
                      otherBranchSteps={otherStatusBranch}
                      className={c.multiStepper}
                    />
                  </section>

                  <section>
                    <header><Typography variant='subtitle2'>{gtFields.reportCompletion}</Typography></header>
                    <Stepper
                      className={c.progressBar}
                      connector={<StepConnector className={c.stepConnector} />}
                    >
                      {steps.map(step => (
                        <Step key={step.id} step={step} />
                      ))}
                    </Stepper>
                  </section>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <section className={hasAlert(job.alerts) ? classNames(c.outlinedSection, 'hasAlert') : null}>
                    <header><Typography variant='subtitle2'>{gtFields.alerts}</Typography></header>
                    <ul className={classNames(c.alertList, `${hasAlert(job.alerts) ? 'hasAlert' : ''}`)}>
                      {
                        hasAlert(job.alerts)
                          ? job.alerts.map(alert => <li key={alert} className={c.alertListItem}>{gt.Alerts[alert]}</li>)
                          : <li key='noAlerts'>{gt.Alerts.noAlerts}</li>
                      }
                    </ul>
                  </section>

                  <Grid container component='section'>
                    <Grid item xs={10}>
                      <header><Typography variant='subtitle2'>{gtFields.team}</Typography></header>
                    </Grid>
                    {
                      !job.locked && userHasPermission(user, permissions.ADD_REMOVE_FROM_TEAM) &&
                      <Grid item xs={2} className={c.fieldActionNotOutlined}>
                        <Button
                          disableRipple
                          onClick={() => this.openDialog('teamDialog')}
                          className={c.editButton}
                          variant='text'
                          color='secondary'
                          style={{ marginTop: 4 }}
                        >
                          {gt.edit}
                        </Button>
                      </Grid>
                    }

                    {
                      job.teamMembers && job.teamMembers.length
                        ? <List className={c.teamMemberList}>
                          {job.teamMembers.map(teamMember =>
                            <ListItem className={c.teamMemberListItem} key={teamMember.userId}>
                              <div className={c.removeTeamMemberButtonContainer}>
                                {!job.locked && !teamMember.active && userHasPermission(user, permissions.ADD_REMOVE_FROM_TEAM) &&
                                  <IconButton className={c.removeTeamMemberButton} onClick={() => this.openDialogWithData('removeTeamMemberDialog', teamMember.userId)}><ClearIcon /></IconButton>
                                }
                              </div>
                              <ListItemText>
                                {`${teamMember.firstName} ${teamMember.lastName} (${teamMember.email})`}
                              </ListItemText>
                            </ListItem>
                          )}
                        </List>
                        : null
                    }
                  </Grid>

                  <section>
                    <header><Typography variant='subtitle2'>{gtFields.customer}</Typography></header>
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography variant='body1'>{removeLeadingZeros(job.customerNumber) || gt.noInfo} {job.customerName || gt.noInfo}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gtFields.address}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.customerAddress || gt.noInfo}</Typography></Grid>
                    </Grid>
                  </section>

                  <section>
                    <header><Typography variant='subtitle2'>{gtFields.customerContact}</Typography></header>
                    <Grid container>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gtFields.contactPerson}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.customerContactPerson || gt.noInfo}</Typography></Grid>

                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gtFields.email}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.customerContactEmail || gt.noInfo}</Typography></Grid>

                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gtFields.phone}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.customerContactPhoneNumber || gt.noInfo}</Typography></Grid>
                    </Grid>
                  </section>

                  <section className={c.outlinedSection}>
                    <header><Typography variant='subtitle2'>{gtFields.jobDetails}</Typography></header>
                    <div className={c.field}>
                      <Typography variant='body1'><i>{gtFields.jobType}</i></Typography>
                      <Typography variant='body1'>{job.jobType || gt.noInfo}</Typography>
                      <Typography variant='body1'>{gtCodes.jobTypeDescription[job.jobType]}</Typography>
                    </div>
                    <div className={c.field}>
                      <Typography variant='body1'><i>{gtFields.serviceProduct}</i></Typography>
                      <Typography variant='body1'>{job.serviceProductNumber || gt.noInfo}</Typography>
                      <Typography variant='body1'>{job.serviceProductDescription}</Typography>
                    </div>
                    <div className={c.field}>
                      <Typography variant='body1'><i>{gtFields.equipment}</i></Typography>
                      <Grid container>
                        <Grid item xs={10}><Typography variant='body1'>
                          {
                            job.equipmentSerialNumber
                              ? removeLeadingZeros(job.equipmentSerialNumber)
                              : <Typography color='error'>{gt.serialNumberMissing}</Typography>
                          }
                        </Typography></Grid>
                        {
                          userHasPermission(user, permissions.EDIT_JOB) && !job.verified && !job.locked &&
                          <Grid item xs={2} className={c.fieldAction}>
                            <Button disableRipple onClick={() => this.openDialog('editEquipmentSerialNumberDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
                          </Grid>
                        }
                        <Grid item xs={10}><Typography variant='body1'>{job.materialNumber}</Typography></Grid>
                        {
                          userHasPermission(user, permissions.EDIT_JOB) && !job.verified && !job.locked &&
                          <Grid item xs={2} className={c.fieldAction}>
                            <Button disableRipple onClick={this.handleEditMaterialNumberClick} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
                          </Grid>
                        }
                      </Grid>
                      <Typography variant='body1'>{job.materialDescription}</Typography>
                    </div>
                    <div className={c.field}>
                      <Typography variant='body1'><i>{gtFields.equipmentWarranty}</i></Typography>
                      <Grid container>
                        <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.start}</i></Typography></Grid>
                        <Grid item xs={10} sm={7}>
                          <Typography variant='body1'>
                            {
                              job.equipmentWarrantyStartDate
                                ? <time dateTime={job.equipmentWarrantyStartDate}>
                                  {moment(job.equipmentWarrantyStartDate).format(timeFormat.DATE)}
                                </time>
                                : gt.noInfo}
                          </Typography>
                        </Grid>
                        {
                          job.manual && !job.locked && userHasPermission(user, permissions.EDIT_JOB) &&
                          <Grid item xs={2} className={c.fieldAction}>
                            <Button disableRipple onClick={() => this.openDialog('warrantyStartDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
                          </Grid>
                        }
                        <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.end}</i></Typography></Grid>
                        <Grid item xs={10} sm={7}>
                          <Typography variant='body1'>
                            {
                              job.equipmentWarrantyEndDate
                                ? <time dateTime={job.equipmentWarrantyEndDate}>
                                  {moment(job.equipmentWarrantyEndDate).format(timeFormat.DATE)}
                                </time>
                                : gt.noInfo}
                          </Typography>
                        </Grid>
                        {
                          job.manual && !job.locked && userHasPermission(user, permissions.EDIT_JOB) &&
                          <Grid item xs={2} className={c.fieldAction}>
                            <Button disableRipple onClick={() => this.openDialog('warrantyEndDialog')} className={c.editButton} variant='text' color='secondary'>{gt.edit}</Button>
                          </Grid>
                        }
                      </Grid>
                    </div>
                    <div className={c.field}>
                      <Typography variant='body1'><i>{gtFields.serviceWarranty}</i></Typography>
                      <Grid container>
                        <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.start}</i></Typography></Grid>
                        <Grid item xs={10} sm={7}>
                          <Typography variant='body1'>
                            {
                              job.serviceWarrantyStartDate
                                ? <time dateTime={job.serviceWarrantyStartDate}>
                                  {moment(job.serviceWarrantyStartDate).format(timeFormat.DATE)}
                                </time>
                                : gt.noInfo}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.end}</i></Typography></Grid>
                        <Grid item xs={10} sm={7}>
                          <Typography variant='body1'>
                            {
                              job.serviceWarrantyEndDate
                                ? <time dateTime={job.serviceWarrantyEndDate}>
                                  {moment(job.serviceWarrantyEndDate).format(timeFormat.DATE)}
                                </time>
                                : gt.noInfo}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                    <Grid container className={c.field}>
                      <Grid item xs={12}><Typography variant='body1'><i>{gtFields.symptom}</i></Typography></Grid>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.group}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.symptomCodeGroup || gt.noInfo}</Typography></Grid>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.code}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.symptomCode || gt.noInfo}</Typography></Grid>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{t.symptomReason}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.symptomText || gt.noInfo}</Typography></Grid>
                    </Grid>
                    <Grid container className={c.field}>
                      <Grid item xs={12}><Typography variant='body1'><i>{gtFields.failure}</i></Typography></Grid>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.group}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.faultCodeGroup || gt.noInfo}</Typography></Grid>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{gt.code}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.faultCode || gt.noInfo}</Typography></Grid>
                      <Grid item xs={12} sm={3}><Typography variant='body1'><i>{t.failureReason}</i></Typography></Grid>
                      <Grid item xs={12} sm={9}><Typography variant='body1'>{job.failureText || gt.noInfo}</Typography></Grid>
                    </Grid>
                  </section>

                  {
                    !job.verified && userHasPermission(user, permissions.EDIT_JOB) &&
                    <section className={c.verifySection}>
                      <Button
                        variant='outlined'
                        color='secondary'
                        disabled={job.locked || (job.reportLevel > 1 && !job.stcHasTechnicalPossibility)}
                        onClick={() => this.openDialog('verifyJobDialog')}
                      >
                        {t.verifyJobDialogTitle}
                      </Button>
                    </section>
                  }
                </Grid>
              </Grid>
            </Fragment>
            : <Loader color='secondary' className={c.loader} />}
        {this.renderReportLevelDialog(c, t, gt)}
        {this.renderApproveReportLevelDialog(c, t, gt)}
        {this.renderTechnicalWarrantyDialog(c, t, gt)}
        {this.renderEditTechnicalWarrantyDialog(c, t, gt)}
        {this.renderAmendTechnicalWarrantyDialog(c, t, gt)}
        {this.renderApproveTechnicalWarrantyDialog(c, t, gt)}
        {this.renderReclassifyTechnicalDecisionDialog(c, t, gt, job)}
        {this.renderCommercialDecisionDialog(c, t, gt)}
        {this.renderAmendCommercialDecisionDialog(c, t, gt)}
        {this.renderApproveCommercialDecisionDialog(c, t, gt)}
        {this.renderPriceDialog(c, t, gt)}
        {this.renderReportStatusDialog(c, t, gt)}
        {this.renderApproveReportStatusDialog(c, t, gt)}
        {this.renderJobStatusDialog(c, t, gt)}
        {this.renderTeamDialog(c, t, gt)}
        {this.renderRemoveTeamMemberConfirmationDialog(c, t, gt)}
        {this.renderEquipmentSerialNumberDialog(c, t, gt)}
        {this.renderMaterialNumberDialog(c, t, gt)}
        {this.renderWarrantyStartDialog(c, t, gt)}
        {this.renderWarrantyEndDialog(c, t, gt)}
        {this.renderReleaseJobDialog(c, t, gt)}
        {this.renderReopenJobDialog(c, t, gt)}
        {this.renderVerifyJobDialog(c, t, gt)}
        {this.renderDeleteConfirmationDialog(c, t, gt)}
        {this.renderDeleteImportedJobConfirmationDialog(c, t, gt)}
        {this.renderEditReleaseMethodDialog(c, t, gt)}
        {this.renderRateTechnicalDecisionDialog(c, t, gt, job)}
        {this.renderChangeInitialWarrantyCodeDialog(c, t, gt)}
      </Paper>
    );
  }
};

const mapStateToProps = state => ({
  searchedTeamMembers: state.singleJob.searchedMembers,
  materialNumberOptions: state.singleJob.materialNumberOptions,
  rateDecision: state.singleJob.actions.technicalWarranty.find(action => action.status === 'APPROVED') && state.singleJob.actions.technicalWarranty.find(action => action.status === 'APPROVED').rateDecision,
  rateComment: state.singleJob.actions.technicalWarranty.find(action => action.status === 'APPROVED') && state.singleJob.actions.technicalWarranty.find(action => action.status === 'APPROVED').rateComment,
  rateVisibilityDateTo: state.singleJob.actions.technicalWarranty.find(action => action.status === 'APPROVED') && state.singleJob.actions.technicalWarranty.find(action => action.status === 'APPROVED').rateVisibilityDateTo,
  chosenMethod: state.singleJob.releaseMethod,
  chosenProposedDate: state.singleJob.proposedDate,
  chosenShipToAddress: state.singleJob.shipToAddress,
  chosenPartNumbers: state.singleJob.partNumbers,
  initialWarrantyCodeOptions: state.singleJob.initialWarrantyCodeOptions,
})

const mapDispatchToProps = dispatch => ({
  actions: {
    addTeamMember: bindActionCreators(addTeamMember, dispatch),
    approveAction: bindActionCreators(approveAction, dispatch),
    approveCommercialDecisionAction: bindActionCreators(approveCommercialDecisionAction, dispatch),
    clearTeamMemberSearch: bindActionCreators(clearSearch, dispatch),
    rateTechnicalDecision: bindActionCreators(rateTechnicalDecision, dispatch),
    removeTeamMember: bindActionCreators(removeTeamMember, dispatch),
    reopenJob: bindActionCreators(reopenJob, dispatch),
    requestReportApproval: bindActionCreators(requestReportApproval, dispatch),
    requestReportLevel: bindActionCreators(requestReportLevel, dispatch),
    proposeWarranty: bindActionCreators(proposeWarranty, dispatch),
    editTechnicalWarrantyProposal: bindActionCreators(editTechnicalWarrantyProposal, dispatch),
    deleteTechnicalWarrantyProposal: bindActionCreators(deleteTechnicalWarrantyProposal, dispatch),
    amendApprovedTecnicalWarrantyProposal: bindActionCreators(amendApprovedTecnicalWarrantyProposal, dispatch),
    deleteApprovedTecnicalWarrantyProposal: bindActionCreators(deleteApprovedTecnicalWarrantyProposal, dispatch),
    amendCommercialDecision: bindActionCreators(amendCommercialDecision, dispatch),
    deleteCommercialDecision: bindActionCreators(deleteCommercialDecision, dispatch),
    reclassifyTechnicalDecision: bindActionCreators(reclassifyTechnicalDecision, dispatch),
    searchTeamMember: bindActionCreators(searchTeamMember, dispatch),
    setStatus: bindActionCreators(setStatus, dispatch),
    setPrice: bindActionCreators(setPrice, dispatch),
    setEquipmentSerialNumber: bindActionCreators(setEquipmentSerialNumber, dispatch),
    getMaterialNumberOptions: bindActionCreators(getMaterialNumberOptions, dispatch),
    clearMaterialNumberOptions: bindActionCreators(clearMaterialNumberOptions, dispatch),
    chooseReleaseMethod: bindActionCreators(chooseReleaseMethod, dispatch),
    setMaterialNumber: bindActionCreators(setMaterialNumber, dispatch),
    setReleaseMethod: bindActionCreators(setReleaseMethod, dispatch),
    setWarrantyDate: bindActionCreators(setWarrantyDate, dispatch),
    verifyJob: bindActionCreators(verifyJob, dispatch),
    deleteJob: bindActionCreators(deleteJob, dispatch),
    deleteImportedJob: bindActionCreators(deleteImportedJob, dispatch),
    clearJob: bindActionCreators(clearJob, dispatch),
    getInitialWarrantyCodes: bindActionCreators(getInitialWarrantyCodes, dispatch),
    editInitialWarrantyCode: bindActionCreators(editInitialWarrantyCode, dispatch),
  }
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(withRouter(JobSummary), 'JobSummary')));



// WEBPACK FOOTER //
// ./src/components/JobSummary/JobSummary.js